import {
  AppBar,
  Button,
  ButtonGroup,
  Checkbox,
  ClickAwayListener,
  Dialog,
  DialogActions,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  LinearProgress,
  ListItemText,
  MenuItem,
  Paper,
  Select,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Switch,
  Tab,
  Tabs,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from '@material-ui/core';
import ArrowBackIos from '@material-ui/icons/ArrowBackIos';
import ArrowForward from '@material-ui/icons/ArrowForward';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import DeleteIcon from '@material-ui/icons/Delete';
import InfoIcon from '@material-ui/icons/Info';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import RefreshIcon from '@material-ui/icons/Refresh';
import SendIcon from '@material-ui/icons/Send';
import { cloneDeep } from 'lodash-es';
import { MTableToolbar } from 'material-table';
import React, { ReactElement } from 'react';

import { getBidderGroups, IBidderGroup } from '~/src/dash/api/bidder-group';
import { IAdserverCampaign } from '~/src/dash/api/campaign/campaign';
import { getChannelGroups } from '~/src/dash/api/channel-group';
import { getSmallSites } from '~/src/dash/api/channels/channels_methods';
import { ISmallSite } from '~/src/dash/api/channels/channels_models';
import {
  getCampaigns,
  IChannelGroup,
  IHeaderBidder,
  queryHeaderBidders,
  ResourceActiveEnabled,
} from '~/src/dash/api/console-api';
import {
  ELiveDataMetrics,
  ELiveDataMetricsKey,
  ELiveDataMetricsString,
  ELiveDataTargetedAvgMetrics,
  ELiveDataTargetedRateMetrics,
} from '~/src/dash/api/live_data/models';
import {
  bulkUpdateMonitors,
  createMonitor,
  createMonitorCustomMetric,
  deleteMonitorCustomMetric,
  getMonitorCustomMetricsByPublisherID,
  getMonitorMinMaxValue,
  getMonitorValue,
  sendTestNotification,
  updateMonitor,
  updateMonitorCustomMetric,
} from '~/src/dash/api/monitors/monitors_methods';
import { acknowledgeMonitorAlerts } from '~/src/dash/api/monitors/monitors_methods';
import {
  EMonitorAlertTimeframe,
  EMonitorMetricDirection,
  EMonitorNotificationProvider,
  EMonitorObjectType,
  EMonitorThresholdComputationType,
  EMonitorTriggerType,
  EMonitorType,
  EnableAutoDisableObjectTypes,
  EnableTargetAllActiveObjectTypes,
  getNotificationProvider,
  IMaxMinMonitorValue,
  IMonitor,
  IMonitorCustomMetric,
  IMonitorNotificationSettings,
  MultiMonitorTypeObjectTypes,
} from '~/src/dash/api/monitors/monitors_models';
import {
  checkThatPeriodAIsWithinPeriodB,
  enrichMonitorAlertsWithTargetedObjectIDsAndNames,
  genMetricDirectionList,
  genObjectTypeList,
  genThresholdComputationTypeList,
  genTimeframeList,
  genTriggerTypeList,
  GetMonitorEditRoute,
  isMetricOnlyValueAlertThreshold,
  isMetricWithoutTimeframe,
  isMonitorObjectTypeWithoutCustomMetricType,
  MonitorObjectTypeToString,
  monitorTargetedMetricConditionTypeToString,
  NumberWithCommas,
  providerToString,
  TargetedMetricConditionCustom,
  TargetedMetricConditionSingle,
  triggerTypeToString,
} from '~/src/dash/api/monitors/monitors_utils';
import {
  generateMonitorCustomMetricList,
  generateMonitorMetricMenuList,
  getSelectedMetricIDFromMenuList,
  getSelectedMonitorCustomMetricFromList,
} from '~/src/dash/api/monitors/monitors_utils';
import { getNetworks, INetwork, transformNetworkWrapper } from '~/src/dash/api/network';
import { IHttpResponse } from '~/src/dash/api/rest';
import { EBool } from '~/src/dash/api/types/bool';
import ConfirmationDialogButton from '~/src/dash/components/confirmation-dialog-button';
import {
  IListTableColumn,
  IMonitorCustomMetricRowData,
  ListTable,
} from '~/src/dash/components/list-table';
import { MaterialSearchDropdownMulti } from '~/src/dash/components/material-search-dropdown-multi';
import { ActiveResourceFilter } from '~/src/dash/components/material-search-dropdown-multi-list';
import {
  MathExpressionEditor,
  transformMathFormula,
} from '~/src/dash/components/math-expression-editor';
import { createDialogWithCustomStyles } from '~/src/dash/components/model-dialog-custom-styles';
import { ModelSecondaryButton } from '~/src/dash/components/model-secondary-button';
import { ModelTopBar } from '~/src/dash/components/model-topbar';
import { ModernTextField } from '~/src/dash/components/modern-text-field';
import {
  GetMonitorNotificationProviderClass,
  GetNotifierList,
} from '~/src/dash/components/monitor/monitor_notifications/notifier_factory';
import {
  getMonitorTriggerType,
  renderMonitorStatus,
} from '~/src/dash/components/monitor/monitor_utils';
import { MonitorHistory } from '~/src/dash/components/monitor/monitor-history';
import PillSwitcher, { IPillItem } from '~/src/dash/components/pill-switcher';
import { activeQuickFilterOptions } from '~/src/dash/components/quick-filter-dropdown';
import { MakeTabProps, TabPanel } from '~/src/dash/components/TabPanel';
import { Col, Cols, Panel, Panels } from '~/src/dash/publicaUI';
import { IStore } from '~/src/dash/reducers/store';
import { getColorTheme } from '~/src/dash/resellers/utils/importResellerConfig';
import { extractRouteParams, navigate, RouteMonitorList } from '~/src/dash/router/routes';
import { FindSelectedFromMenuList, IListItem, IMenuList } from '~/src/dash/types/menuList';
import {
  IBaseState,
  IHistoryProps,
  IReduxActionProps,
  ISessionStateProps,
  IUserStateProps,
  IWithStylesProps,
} from '~/src/dash/types/props';
import { IBulkUpdateItem, IBulkUpdateMap } from '~/src/dash/utils/bulk-update';
import { publicaColors } from '~/src/dash/utils/colors';
import { decorate } from '~/src/dash/utils/decorator';
import { genBiddersMenuList } from '~/src/dash/utils/header-bidder-adapters';
import { backgroundColor } from '~/src/dash/utils/material-dashboard-react';
import { noopVoid } from '~/src/dash/utils/noop';
import { checkUserInfoMasked, hasRoleSuperUser } from '~/src/dash/utils/roles';
import { routeName } from '~/src/dash/utils/routes';
import {
  customMetricValidatorSetting,
  hasErrors,
  validatorFactory,
} from '~/src/dash/utils/validator';
import { ButtonView } from '~/src/dash/views/button-view';
import { RowButton } from '~/src/dash/views/component-view';
import { SnackbarView } from '~/src/dash/views/snackbar-view';
import { highlight, languages } from '~/src/prismjs';

const MONITOR_TARGETED_METRIC_TYPE_PILLS: IPillItem[] = [
  {
    text: monitorTargetedMetricConditionTypeToString(TargetedMetricConditionSingle),
  },
  {
    text: monitorTargetedMetricConditionTypeToString(TargetedMetricConditionCustom),
  },
];

const allActiveEnableTargetAll = 'All Active';
const customEnableTargetAll = 'Custom';

const ENABLE_TARGET_ALL_ACTIVE_PILLS: IPillItem[] = [
  {
    text: allActiveEnableTargetAll,
  },
  {
    text: customEnableTargetAll,
  },
];

const percentageEnabledText = 'Percentage';
const valueEnabledText = 'Value';

const MONITOR_AS_PERCENTAGE_PILLS: IPillItem[] = [
  {
    text: percentageEnabledText,
  },
  {
    text: valueEnabledText,
  },
];

interface IProps
  extends IWithStylesProps,
    IReduxActionProps,
    ISessionStateProps,
    IUserStateProps,
    IHistoryProps {
  monitor: IMonitor;
  allMonitors: IMonitor[];
  bulkUpdateIDs: string[];
  fetchMonitor: () => void;
}

export interface IState extends IBaseState {
  monitor: IMonitor;

  // api data
  channelList: IMenuList;
  bidderList: IMenuList;
  campaignList: IMenuList;
  bidderGroupList: IMenuList;
  channelGroupList: IMenuList;
  demandSourceList: IMenuList;
  objectTypeList: IMenuList;
  networkList: IMenuList;

  metricDirectionList: IMenuList;
  thresholdComputationTypeList: IMenuList;
  averagePeriodList: IListItem[];
  timeframeList: IListItem[];

  // bulk update related fileds
  bulkUpdateEnabledFields: IBulkUpdateMap;

  // snackbar
  snackbarMessage: string;
  snackbarError: boolean;

  debugValue: number;
  maxMinValue: IMaxMinMonitorValue;
  isMutedUntilTooltipOpen: boolean;
  updating: boolean;
  viewTabIndex: number;
  monitorValuesLoading: boolean;

  // custom metrics
  openCustomMetricTable: boolean;
  openCustomMetricCreateEditDialog: boolean;
  updatingCustomMetrics: boolean;
  createEditCustomMetricID: string;
  createEditCustomMetricName: string;
  createEditCustomMetricAList: IMenuList;
  createEditCustomMetricBList: IMenuList;
  createEditCustomMetricFormula: string;
  createEditTestCustomMetricTimeframe: EMonitorAlertTimeframe;
  customMetricFormulaError: string | null;

  openRecentValue: boolean;
}

interface IMutedUntilOptions {
  title: string;
  timeOffset: number;
}

const mutedUntilOptionsList = [
  { title: 'Unmute', timeOffset: null },
  { title: '1h', timeOffset: 1 },
  { title: '4h', timeOffset: 4 },
  { title: '12h', timeOffset: 12 },
  { title: '1d', timeOffset: 24 },
  { title: '1w', timeOffset: 24 * 7 },
] as IMutedUntilOptions[];

const Icons = {
  0: {
    // above
    CurrentValue: ArrowForward,
    Alert: ArrowForwardIosIcon,
    Warning: ArrowForwardIosIcon,
    AlertRecovery: ArrowForwardIosIcon,
    WarningRecovery: ArrowForwardIosIcon,
  },
  1: {
    // under
    CurrentValue: ArrowForward,
    Alert: ArrowBackIos,
    Warning: ArrowBackIos,
    AlertRecovery: ArrowBackIos,
    WarningRecovery: ArrowBackIos,
  },
};

function GetIconDirection(dir: EMonitorMetricDirection) {
  if (dir === EMonitorMetricDirection.MonitorMetricDirection_ABOVE) {
    return Icons['0'];
  } else {
    return Icons['1'];
  }
}

// compare a >= b
// if reversed, a <= b
const compareThresholds = (a: number, b: number, reversed: boolean): boolean => {
  if (reversed) {
    return a <= b;
  }
  return a >= b;
};

const getSaveButtonStyles = () => {
  return {
    backgroundColor: getColorTheme('channelBidderPrimaryButton'),
    color: getColorTheme('channelBidderPrimaryButtonText'),
  };
};

const formatTimeDifference = (diffInMilliSeconds: number): string => {
  diffInMilliSeconds = Math.abs(diffInMilliSeconds) / 1000;

  // calculate days
  const days = Math.floor(diffInMilliSeconds / 86400);
  diffInMilliSeconds -= days * 86400;

  // calculate hours
  const hours = Math.floor(diffInMilliSeconds / 3600) % 24;
  diffInMilliSeconds -= hours * 3600;

  // calculate minutes
  const minutes = Math.floor(diffInMilliSeconds / 60) % 60;

  let difference = '';
  if (days > 0) {
    difference += days === 1 ? `${days} d, ` : `${days} d, `;
  }

  difference += hours === 0 || hours === 1 ? `${hours} h, ` : `${hours} hrs, `;

  difference += minutes === 0 || hours === 1 ? `${minutes} m` : `${minutes} mns`;

  return difference;
};

const DialogWidth730 = createDialogWithCustomStyles({ paperWidthMd: { width: '730px' } });

export const EditMonitor = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
    styles: (theme: any) => ({
      paper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 4,
      },
      section: {
        display: 'block',
        marginBottom: theme.spacing.unit * 2,
      },
      button: {
        margin: theme.spacing.unit,
      },
      checkbox: {
        transform: 'scale(0.8)',
        padding: 3,
      },
      drawerPaper: {
        width: '80%',
      },
      insideAccordionText: {
        fontSize: 12,
        fontWeight: 400,
        color: '$434343',
      },
      headingCategorySubtitle: {
        fontSize: 14,
        fontWeight: 400,
        color: '$434343',
        marginBottom: 15,
      },
      insideAccordionTextfield: {
        fontSize: 12,
        fontWeight: 400,
        backgroundColor: '#F4F6FD',
        paddingLeft: 5,
        paddingTop: 8,
        paddingBottom: 8,
      },
      insideAccordionTextBold: {
        fontSize: 12,
        fontWeight: 500,
        color: '$434343',
      },
      headingCategoryTitle: {
        fontSize: 18,
        fontWeight: 500,
        color: '$434343',
        marginBottom: 5,
      },
      headingCategorySubTitle: {
        fontSize: 16,
        fontWeight: 500,
        color: '$434343',
        marginTop: 10,
      },
      redBackground: {
        background: '#E504040D',
      },
      yellowBackground: {
        background: '#FAEE5D0D',
      },
      greenBackground: {
        background: '#CAECE924',
      },
      thresholdsIcons: { marginTop: '14px', marginRight: '5px' },
      indicator: {
        color: '#4952FF',
        backgroundColor: '#4952FF',
      },
      stepperLabel: {
        fontSize: '16px',
        fontWeight: 500,
      },
      fullWidthTooltip: {
        maxWidth: '100%',
        backgroundColor: '#fff',
      },
    }),
    router: true,
  },
  class extends React.Component<IProps, IState> {
    state = {
      monitor: this.props.monitor,
      monitorValuesLoading: false,
      bidderList: {} as IMenuList,
      campaignList: {} as IMenuList,
      bidderGroupList: {} as IMenuList,
      channelGroupList: {} as IMenuList,
      channelList: {} as IMenuList,
      demandSourceList: {} as IMenuList,
      networkList: {} as IMenuList,

      objectTypeList: genObjectTypeList(this.props.monitor.TargetedObjectType),
      metricDirectionList: genMetricDirectionList(this.props.monitor.MetricDirection),
      thresholdComputationTypeList: genThresholdComputationTypeList(
        this.props.monitor.ThresholdComputation,
        !!ELiveDataTargetedRateMetrics[this.props.monitor.TargetedMetric],
        !!ELiveDataTargetedAvgMetrics[this.props.monitor.TargetedMetric],
      ),
      averagePeriodList: genTimeframeList(
        this.props.monitor.AveragePeriod,
        isMetricWithoutTimeframe(this.props.monitor.TargetedMetric),
      ),
      timeframeList: genTimeframeList(
        this.props.monitor.AlertTimeframe,
        isMetricWithoutTimeframe(this.props.monitor.TargetedMetric),
      ),
      // bulk update related fileds
      bulkUpdateEnabledFields: {} as IBulkUpdateMap,

      // snackbar
      snackbarMessage: '',
      snackbarError: false,

      debugValue: -1,
      maxMinValue: {} as IMaxMinMonitorValue,
      isMutedUntilTooltipOpen: false,
      updating: false,
      viewTabIndex: 0,

      // custom metrics
      openCustomMetricTable: false,
      openCustomMetricCreateEditDialog: false,
      updatingCustomMetrics: false,
      createEditCustomMetricID: '',
      createEditCustomMetricName: '',
      createEditCustomMetricFormula: '',
      createEditTestCustomMetricTimeframe: 5 as EMonitorAlertTimeframe, // default 24 hours
      createEditTestTimeFrameList: genTimeframeList(5), // use default 24 hours selected
      createEditCustomMetricAList: generateMonitorMetricMenuList(true) as IMenuList,
      createEditCustomMetricBList: generateMonitorMetricMenuList(true) as IMenuList,
      customMetricFormulaError: '',

      customMetricTestDebugVal: -1,
      customMetricTestMaxMinVal: {} as IMaxMinMonitorValue,
      openRecentValue: true,
    };

    componentDidMount() {
      // async
      const asyncFunc = async () => {
        const small_sites = await this.fetchChannelList();
        this.fetchBidderList(small_sites.map((s: ISmallSite) => s.ID));
      };
      asyncFunc();

      this.fetchBidderGroupList();
      this.fetchChannelGroupList();
      this.fetchCampaignList();
      this.fetchDemandSourceList();
      this.fetchNetworkList();
    }

    componentDidUpdate(_: any, prevState: Readonly<IState>) {
      if (prevState.monitor.TargetedObjectType !== this.state.monitor.TargetedObjectType) {
        this.updateMonitorState({
          monitorDefinedMetricsList: generateMonitorMetricMenuList(
            false,
            undefined,
            undefined,
            this.state.monitor.TargetedObjectType,
          ),
        });
      }
    }

    // adds list info to the monitor alerts for links and names in <MonitorHistory/>
    enrichMonitorAlerts = () => {
      const { monitor } = this.state;
      let list = this.state.channelList;

      if (
        monitor.TargetedObjectType === EMonitorObjectType.MonitorObjectType_BIDDER ||
        (monitor.TargetedObjectType === EMonitorObjectType.MonitorObjectType_BIDDER_GROUP &&
          monitor.MonitorType === EMonitorType.MonitorType_MULTI)
      ) {
        list = this.state.bidderList;
      } else if (
        monitor.TargetedObjectType === EMonitorObjectType.MonitorObjectType_CAMPAIGN ||
        monitor.TargetedObjectType === EMonitorObjectType.MonitorObjectType_CHECKPOINT
      ) {
        list = this.state.campaignList;
      } else if (monitor.TargetedObjectType === EMonitorObjectType.MonitorObjectType_NETWORK) {
        list = this.state.networkList;
      } else if (
        monitor.TargetedObjectType === EMonitorObjectType.MonitorObjectType_BIDDER_GROUP &&
        monitor.MonitorType === EMonitorType.MonitorType_SINGLE
      ) {
        list = this.state.bidderGroupList;
      } else if (
        monitor.TargetedObjectType === EMonitorObjectType.MonitorObjectType_CHANNEL_GROUP &&
        monitor.MonitorType === EMonitorType.MonitorType_SINGLE
      ) {
        list = this.state.channelGroupList;
      }

      this.setState({
        monitor: enrichMonitorAlertsWithTargetedObjectIDsAndNames(this.state.monitor, list),
      });
    };

    fetchChannelList = async (): Promise<ISmallSite[]> => {
      const { monitor } = this.state;
      const { session, user } = this.props;

      let selectedSites = [] as string[];
      if (monitor.TargetedObjectType === EMonitorObjectType.MonitorObjectType_SITE) {
        selectedSites = monitor.TargetedObject.split(',');
      }

      const channelList: IMenuList = {};

      // get sites
      const [small_sites, err] = await getSmallSites(session.publisher.ID);
      if (err) {
        console.error(err);
        return [];
      }

      (small_sites || []).forEach((site: ISmallSite) => {
        const siteName = checkUserInfoMasked(user.user) ? 'demo_site_' + site.ID : site.Name;
        channelList[site.ID] = {
          title: siteName,
          selected: selectedSites.includes(site.ID.toString()),
          ID: site.ID.toString(),
        };
      });

      this.setState(
        {
          channelList,
        },
        () => {
          this.enrichMonitorAlerts();
          if (monitor.TargetedObjectType === EMonitorObjectType.MonitorObjectType_SITE) {
            this.updateMonitorState({
              TargetedObject: this.getTargetedObjects(monitor.TargetedObjectType),
            });
          }
        },
      );
      return small_sites || [];
    };

    fetchBidderList = (site_ids: number[]) => {
      const { monitor } = this.state;
      const { session, user } = this.props;

      queryHeaderBidders({
        query: {
          publisher_id: session.publisher.ID,
          include_deleted: false,
        },
        body: {
          site_ids: site_ids.join(','),
        },
      }).then((hbs: IHeaderBidder[]) => {
        let selectedBidders = [] as string[];
        if (monitor.TargetedObjectType === EMonitorObjectType.MonitorObjectType_BIDDER) {
          selectedBidders = monitor.TargetedObject.split(',');
        }

        const bidderList: IMenuList = {};

        hbs.forEach((hb: IHeaderBidder) => {
          const bidderName = checkUserInfoMasked(user.user) ? 'demo_bidder_' + hb.ID : hb.Name;
          bidderList[hb.ID] = {
            title: bidderName,
            selected: selectedBidders.includes(hb.ID.toString()),
            ID: hb.ID.toString(),
            active: hb.Active === ResourceActiveEnabled,
          };
        });

        this.setState(
          {
            bidderList,
          },
          () => {
            this.enrichMonitorAlerts();
            if (monitor.TargetedObjectType === EMonitorObjectType.MonitorObjectType_BIDDER) {
              this.updateMonitorState({
                TargetedObject: this.getTargetedObjects(monitor.TargetedObjectType),
              });
            }
          },
        );
      });
    };

    fetchCampaignList = () => {
      const { monitor } = this.state;
      const { session, user } = this.props;

      getCampaigns({
        query: {
          publisher_id: session.publisher.ID,
        },
      }).then((campaigns: IAdserverCampaign[]) => {
        let selectedCampaigns = [] as string[];
        if (
          monitor.TargetedObjectType === EMonitorObjectType.MonitorObjectType_CAMPAIGN ||
          monitor.TargetedObjectType === EMonitorObjectType.MonitorObjectType_CHECKPOINT
        ) {
          selectedCampaigns = monitor.TargetedObject.split(',');
        }

        const campaignList: IMenuList = {};

        campaigns.forEach((c: IAdserverCampaign) => {
          const campaignName = checkUserInfoMasked(user.user) ? 'demo_campaign_' + c.ID : c.Name;
          campaignList[c.ID] = {
            title: campaignName,
            selected: selectedCampaigns.includes(c.ID.toString()),
            ID: c.ID.toString(),
            orderID: c.AdserverOrderID,
          };
        });

        this.setState(
          {
            campaignList,
          },
          () => {
            this.enrichMonitorAlerts();
            if (
              monitor.TargetedObjectType === EMonitorObjectType.MonitorObjectType_CAMPAIGN ||
              monitor.TargetedObjectType === EMonitorObjectType.MonitorObjectType_CHECKPOINT
            ) {
              this.updateMonitorState({
                TargetedObject: this.getTargetedObjects(monitor.TargetedObjectType),
              });
            }
          },
        );
      });
    };

    fetchBidderGroupList = () => {
      const { monitor } = this.state;
      const { session } = this.props;

      getBidderGroups({
        query: {
          publisher_id: session.publisher.ID,
        },
      }).then(({ bidderGroups }: { bidderGroups: IBidderGroup[] }) => {
        let selectedBidderGroups = [] as string[];
        if (monitor.TargetedObjectType === EMonitorObjectType.MonitorObjectType_BIDDER_GROUP) {
          selectedBidderGroups = monitor.TargetedObject.split(',');
        }

        const bidderGroupList: IMenuList = {};

        bidderGroups.forEach((bg: IBidderGroup) => {
          bidderGroupList[bg.ID] = {
            title: bg.Name,
            selected: selectedBidderGroups.includes(bg.ID.toString()),
            ID: bg.ID.toString(),
          };
        });

        this.setState(
          {
            bidderGroupList,
          },
          () => {
            this.enrichMonitorAlerts();
            if (monitor.TargetedObjectType === EMonitorObjectType.MonitorObjectType_BIDDER_GROUP) {
              this.updateMonitorState({
                TargetedObject: this.getTargetedObjects(monitor.TargetedObjectType),
              });
            }
          },
        );
      });
    };

    fetchChannelGroupList = () => {
      const { monitor } = this.state;
      const { session } = this.props;

      getChannelGroups({
        query: {
          publisher_id: session.publisher.ID,
        },
      }).then(({ channelGroups }: { channelGroups: IChannelGroup[] }) => {
        let selectedChannelGroups = [] as string[];
        if (monitor.TargetedObjectType === EMonitorObjectType.MonitorObjectType_CHANNEL_GROUP) {
          selectedChannelGroups = monitor.TargetedObject.split(',');
        }

        const channelGroupList: IMenuList = {};

        channelGroups.forEach((bg: IChannelGroup) => {
          channelGroupList[bg.ID] = {
            title: bg.Name,
            selected: selectedChannelGroups.includes(bg.ID.toString()),
            ID: bg.ID.toString(),
          };
        });

        this.setState(
          {
            channelGroupList,
          },
          () => {
            this.enrichMonitorAlerts();
            if (monitor.TargetedObjectType === EMonitorObjectType.MonitorObjectType_CHANNEL_GROUP) {
              this.updateMonitorState({
                TargetedObject: this.getTargetedObjects(monitor.TargetedObjectType),
              });
            }
          },
        );
      });
    };

    fetchNetworkList = () => {
      const { monitor } = this.state;
      const { session } = this.props;

      getNetworks(session.publisher.ID)
        .then((val: IHttpResponse<INetwork[]>) => {
          const networks = [] as INetwork[];

          if (val.parsedBody) {
            for (const item of val.parsedBody) {
              const network = transformNetworkWrapper(item);
              networks.push(network);
            }
          }

          const networkList: IMenuList = {};

          let selectedNetworkIDs = [] as string[];
          if (monitor.TargetedObjectType === EMonitorObjectType.MonitorObjectType_NETWORK) {
            selectedNetworkIDs = monitor.TargetedObject.split(',');
          }

          networks.forEach((network: INetwork) => {
            networkList[network.ID] = {
              title: network.Name,
              selected: selectedNetworkIDs.includes(network.ID.toString()),
              ID: network.ID.toString(),
            };
          });
          this.setState(
            {
              networkList,
            },
            () => {
              this.enrichMonitorAlerts();
              if (monitor.TargetedObjectType === EMonitorObjectType.MonitorObjectType_NETWORK) {
                this.updateMonitorState({
                  TargetedObject: this.getTargetedObjects(monitor.TargetedObjectType),
                });
              }
            },
          );
        })
        .catch(() => {
          this.setState({
            networks: [] as INetwork[],
            snackbarError: true,
            snackbarMessage: 'Error while getting the list of networks from the API.',
            loading: false,
          });
        });
    };

    fetchDemandSourceList = () => {
      const { monitor } = this.state;
      const { session, user } = this.props;

      let demandSourceList: IMenuList = genBiddersMenuList(
        [],
        session.publisher,
        [],
        '',
        hasRoleSuperUser(user.user),
      );
      // populate selected values
      if (
        monitor.TargetedObjectType === EMonitorObjectType.MonitorObjectType_DEMAND_SOURCE &&
        monitor.TargetedObject !== ''
      ) {
        // remove the `PUBID_` from this list
        // @ts-ignore
        const targetedDemandSources = monitor.TargetedObject.replaceAll(
          monitor.PublisherID + '_',
          '',
        ).split(',');
        demandSourceList = genBiddersMenuList(
          targetedDemandSources,
          session.publisher,
          [],
          '',
          hasRoleSuperUser(user.user),
        );
      }

      this.setState(
        {
          demandSourceList,
        },
        () => {
          if (monitor.TargetedObjectType === EMonitorObjectType.MonitorObjectType_DEMAND_SOURCE) {
            this.updateMonitorState({
              TargetedObject: this.getTargetedObjects(monitor.TargetedObjectType),
            });
          }
        },
      );
    };

    fetchMonitorCustomMetricsByPublisherID = (
      setNewCustomMetric: boolean,
      updatedMetricID?: number,
    ) => {
      getMonitorCustomMetricsByPublisherID(this.props.session.publisher.ID).then((data) => {
        const monitorCustomMetrics = data[0];

        if (monitorCustomMetrics && setNewCustomMetric) {
          // set as selected the new custom metric in dropdown, or the updated custom metric in dropdown
          let customMetricToSelect = monitorCustomMetrics[monitorCustomMetrics.length - 1];
          if (updatedMetricID) {
            customMetricToSelect = monitorCustomMetrics.filter(
              (customMetric) => customMetric.ID === updatedMetricID,
            )[0];
          }

          this.updateMonitorState({
            ThresholdComputation:
              EMonitorThresholdComputationType.MonitorThresholdComputationType_SUM,
            TargetedMetric: ELiveDataMetrics.METRICS_IDENTIFIER_CUSTOM_METRIC,
            MonitorCustomMetric: customMetricToSelect,
            MonitorCustomMetricID: customMetricToSelect.ID,
            monitorCustomMetrics,
            monitorCustomMetricsList: generateMonitorCustomMetricList(
              monitorCustomMetrics,
              customMetricToSelect.ID,
            ) as IMenuList,
          });
        } else if (monitorCustomMetrics) {
          this.updateMonitorState({
            monitorCustomMetrics,
            monitorCustomMetricsList: generateMonitorCustomMetricList(
              monitorCustomMetrics,
              this.state.monitor.MonitorCustomMetricID,
            ) as IMenuList,
          });
        }
      });
    };

    handleChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
      this.setState(
        Object.assign({
          [target.name]: target.value,
        }),
      );
    };

    // we can use enable auto disable if using multi monitor type
    // and the type is in EnableAutoDisableObjectTypes
    isEnableAutoDisableAllowed = (objType: EMonitorObjectType): boolean => {
      return (
        this.isMultiMonitorTypeAllowed(objType) &&
        EnableAutoDisableObjectTypes.includes(objType) &&
        this.state.monitor.MonitorType === EMonitorType.MonitorType_MULTI
      );
    };

    // we can use multi monitor type if object type in MultiMonitorTypeObjectTypes
    isMultiMonitorTypeAllowed = (objType: EMonitorObjectType): boolean => {
      return MultiMonitorTypeObjectTypes.includes(objType);
    };

    // we can use enableTargetAllActive if object type in EnableTargetAllActiveObjectTypes
    isEnableTargetAllActiveAllowed = (objType: EMonitorObjectType): boolean => {
      return EnableTargetAllActiveObjectTypes.includes(objType);
    };

    // return promise with success or not
    saveMonitor = (): Promise<boolean> => {
      const { session } = this.props;
      const { monitor } = this.state;

      // check notifications
      for (const n of monitor.NotificationsSettings || []) {
        const cl = GetMonitorNotificationProviderClass(n.Provider);
        if (cl === undefined) {
          this.setState({
            snackbarMessage: 'Error validating a notification',
            snackbarError: true,
          });
          return new Promise<boolean>((resolve) => resolve(false));
        }
        const err = cl.Validate(n);
        if (err && err !== '') {
          this.setState({
            snackbarMessage: 'Error validating a notification: ' + err,
            snackbarError: true,
          });
          return new Promise<boolean>((resolve) => resolve(false));
        }
      }

      this.setState({
        updating: true,
      });

      // check
      // alert if selected metric is empty -> you must choose a metric
      const errBeforeSave = this.checkBeforeSave();
      if (errBeforeSave !== undefined) {
        this.setState({
          snackbarMessage: errBeforeSave,
          snackbarError: true,
          updating: false,
        });
        return new Promise<boolean>((resolve) => resolve(false));
      }

      const saveRestFunction = monitor.ID === 0 ? createMonitor : updateMonitor;
      return saveRestFunction(monitor, session.publisher.ID).then(([newMonitor, err]) => {
        if (err !== undefined) {
          this.setState({
            snackbarMessage: String(err),
            snackbarError: true,
            updating: false,
          });
          console.error(err);
          return false;
        }
        this.setState({
          snackbarMessage: 'Successfully saved monitor!',
          snackbarError: false,
          updating: false,
        });

        if (newMonitor !== undefined && newMonitor.ID !== 0) {
          navigate(GetMonitorEditRoute(newMonitor, this.props));
        }
        return true;
      });
    };

    updateBulkUpdateMonitors = () => {
      const monitor = this.state.monitor as any;
      const updates = {} as { [key: string]: any };

      for (const item of Object.values(this.state.bulkUpdateEnabledFields)) {
        // handle specific cases where we cannot simply use state in the update map
        if (item.enabled) {
          if (
            [
              'AlertThreshold',
              'WarningThreshold',
              'AlertRecoveryThreshold',
              'WarningRecoveryThreshold',
              'IsPercentage',
            ].includes(item.key)
          ) {
            updates[item.key] = monitor.AlertThresholds[item.key];
          } else {
            updates[item.key] = monitor[item.key];
          }
        }
      }

      if (Object.keys(updates).length === 0) {
        this.setState({
          snackbarMessage:
            'Use the checkbox to the left of field name to select a field to bulk edit',
          snackbarError: true,
        });
        return;
      }

      bulkUpdateMonitors(
        this.props.bulkUpdateIDs.join(','),
        this.props.session.publisher.ID,
        updates,
        Object.keys(updates)
          .map((key) => key)
          .join(','),
      )
        .then(() => {
          this.setState({
            snackbarMessage: 'Successfully updated monitors',
            snackbarError: false,
          });
        })
        .catch(() => {
          this.setState({
            snackbarMessage: 'Failed to update monitors',
            snackbarError: true,
          });
        });
    };

    // query api to get the current and past values for this monitor
    getValuesForTheseParameters = () => {
      // transform state to monitor
      const {
        monitor,
        openCustomMetricCreateEditDialog,
        createEditCustomMetricAList,
        createEditCustomMetricBList,
        createEditCustomMetricFormula,
        createEditCustomMetricName,
        createEditTestCustomMetricTimeframe,
      } = this.state;
      this.setState({
        monitorValuesLoading: true,
      });

      const monitorClone = cloneDeep(monitor);

      // check for errors
      let errBeforeSave = this.checkBeforeSave(false);

      // if create edit custom metric modal is open, then run a custom metric test calculation instead
      if (openCustomMetricCreateEditDialog) {
        // fill out monitor for testing custom metric formula
        monitorClone.MonitorCustomMetric.ID = 0;
        monitorClone.AlertTimeframe = createEditTestCustomMetricTimeframe;
        monitorClone.ThresholdComputation =
          EMonitorThresholdComputationType.MonitorThresholdComputationType_SUM;
        monitorClone.TargetedMetric = ELiveDataMetrics.METRICS_IDENTIFIER_CUSTOM_METRIC;
        monitorClone.MonitorCustomMetric.CustomMetricA = getSelectedMetricIDFromMenuList(
          createEditCustomMetricAList,
        );
        monitorClone.MonitorCustomMetric.CustomMetricB = getSelectedMetricIDFromMenuList(
          createEditCustomMetricBList,
        );
        monitorClone.MonitorCustomMetric.MetricFormula = transformMathFormula(
          createEditCustomMetricFormula,
        );
        monitorClone.MonitorCustomMetric.Name = createEditCustomMetricName;
        // enforce object targeted selection for testing custom metric
        if (
          monitor.EnableTargetAllActive === EBool.EBool_FALSE &&
          (monitor.TargetedObject === undefined || monitor.TargetedObject === '')
        ) {
          errBeforeSave = 'No object targeted';
        } else {
          errBeforeSave = undefined;
        }
      }

      if (errBeforeSave !== undefined) {
        this.setState({
          snackbarMessage: errBeforeSave,
          snackbarError: true,
          monitorValuesLoading: false,
        });
        return;
      }

      Promise.all([
        getMonitorValue(monitorClone, this.props.session.publisher.ID).then(([value, err]) => {
          if (err !== undefined) {
            console.error(err);
            this.setState({
              snackbarMessage: String(err),
              snackbarError: true,
            });
          } else {
            if (value !== undefined) {
              // if value is for Custom Metric Test Calculation
              if (openCustomMetricCreateEditDialog) {
                this.setState({
                  customMetricTestDebugVal: value,
                });
              } else {
                this.setState({
                  debugValue: value,
                });
              }
            }
          }
        }),
        getMonitorMinMaxValue(monitorClone, this.props.session.publisher.ID).then(
          ([value, err]) => {
            if (err !== undefined) {
              console.error(err);
              this.setState({
                snackbarMessage: String(err),
                snackbarError: true,
              });
            } else {
              if (value !== undefined) {
                // if value is for Custom Metric Test Calculation
                if (openCustomMetricCreateEditDialog) {
                  this.setState({
                    customMetricTestMaxMinVal: value,
                  });
                } else {
                  this.setState({
                    maxMinValue: value,
                  });
                }
              }
            }
          },
        ),
      ]).then(() => {
        this.setState({
          monitorValuesLoading: false,
        });
      });
    };

    checkIfRowIsMarked = (fields: string[]): boolean => {
      const { bulkUpdateEnabledFields } = this.state;
      for (const field of fields) {
        if (
          bulkUpdateEnabledFields[field] === undefined ||
          !bulkUpdateEnabledFields[field].enabled
        ) {
          return false;
        }
      }
      return true;
    };

    bulkUpdateEnabledFieldsContainField = (field: string): boolean => {
      const { bulkUpdateEnabledFields } = this.state;
      return (
        Object.keys(bulkUpdateEnabledFields).filter(
          (key) => bulkUpdateEnabledFields[key].key === field,
        ).length > 0
      );
    };

    bulkUpdateEnabledFieldsContainFieldAndEnabled = (field: string): boolean => {
      const { bulkUpdateEnabledFields } = this.state;
      const containField =
        Object.keys(bulkUpdateEnabledFields).filter(
          (key) => bulkUpdateEnabledFields[key].key === field,
        ).length > 0;

      if (containField) {
        return bulkUpdateEnabledFields[field].enabled;
      }
      return false;
    };

    handleChangeMarked = (bulkUpdateItems: IBulkUpdateItem[]): void => {
      const bulkUpdateEnabledFields = cloneDeep(this.state.bulkUpdateEnabledFields);
      for (const item of bulkUpdateItems) {
        if (item.key === 'AlertTimeframe' && this.state.monitor.AlertThresholds.IsPercentage) {
          if (this.bulkUpdateEnabledFieldsContainField('AlertTimeframe')) {
            bulkUpdateEnabledFields[item.key].enabled = true;
          } else {
            bulkUpdateEnabledFields.AlertTimeframe = {
              key: 'AlertTimeframe',
              displayTitle: 'Alert Timeframe',
              genDisplayValue: (): string => {
                if (
                  this.state.monitor.AlertTimeframe ===
                  EMonitorAlertTimeframe.MonitorAlertTimeframe_Past48H_To_24H
                ) {
                  return 'past 48H <-> 24H';
                }
                const selectedItem = this.state.timeframeList.filter(
                  (listItem: IListItem) => listItem.selected,
                );
                if (selectedItem.length) {
                  return selectedItem[0].title;
                }
                return '';
              },
              enabled: true,
            };
          }
        } else if (bulkUpdateEnabledFields[item.key] === undefined) {
          bulkUpdateEnabledFields[item.key] = item;
          bulkUpdateEnabledFields[item.key].enabled = true;
        } else if (bulkUpdateEnabledFields[item.key].enabled) {
          bulkUpdateEnabledFields[item.key].enabled = false;
        } else {
          bulkUpdateEnabledFields[item.key].enabled = true;
        }
      }
      this.setState({
        bulkUpdateEnabledFields,
      });
    };

    handleDisableMarkedForBulkUpdate = (key: string) => {
      const bulkUpdateEnabledFields = cloneDeep(this.state.bulkUpdateEnabledFields);
      if (key in bulkUpdateEnabledFields) {
        bulkUpdateEnabledFields[key].enabled = false;
      }
      this.setState({
        bulkUpdateEnabledFields,
      });
    };

    handleAcknowledgeMonitorAlerts = (alertIDs: string[], acknowledgeAlerts: boolean) => {
      acknowledgeMonitorAlerts(
        this.state.monitor.ID.toString(),
        alertIDs,
        this.props.session.publisher.ID,
        acknowledgeAlerts,
      )
        .then((resp) => {
          if (resp[0]) {
            this.updateMonitorState(
              {
                AlertHistory: resp[0],
              },
              this.enrichMonitorAlerts,
            );
          }
        })
        .catch(() => {
          this.setState({
            snackbarError: true,
            snackbarMessage: 'Failed to acknowledge alerts',
          });
        });
    };

    /* Custom Metric handlers */
    handleSetUpdatingCustomMetric = (updatingCustomMetrics: boolean) => {
      this.setState({ updatingCustomMetrics });
    };

    handleDeleteCustomMetric = (customMetricID: string, reloadCustomMetrics: boolean) => {
      const { monitor } = this.state;

      const foundCustomMetric = monitor.monitorCustomMetrics.find(
        (customMetric) => customMetric.ID.toString() === customMetricID,
      );
      if (foundCustomMetric) {
        const clonedCustomMetricsList = cloneDeep(monitor.monitorCustomMetricsList);
        delete clonedCustomMetricsList[customMetricID];

        deleteMonitorCustomMetric(customMetricID, this.props.session.publisher.ID).then(() => {
          this.setState(
            {
              openCustomMetricCreateEditDialog: false,
              openCustomMetricTable: false,
              updatingCustomMetrics: false,
              snackbarMessage: 'Sucessfully deleted custom metric',
              snackbarError: false,
            },
            reloadCustomMetrics
              ? () => this.fetchMonitorCustomMetricsByPublisherID(false)
              : undefined,
          );
        });
      }
    };

    handleCustomMetricModalClose = (redirectToAllCustomMetrics?: boolean) => {
      this.setState({
        createEditCustomMetricID: '',
        createEditCustomMetricName: '',
        createEditCustomMetricFormula: '',
        createEditCustomMetricAList: generateMonitorMetricMenuList(true) as IMenuList,
        createEditCustomMetricBList: generateMonitorMetricMenuList(true) as IMenuList,
        openCustomMetricCreateEditDialog: false,
        openCustomMetricTable: !!redirectToAllCustomMetrics,
      });
    };

    handleSaveEditCustomMetric = (
      createEditCustomMetricID: string,
      newMonitorCustomMetric: IMonitorCustomMetric,
      customMetricFormulaError: string,
    ) => {
      if (this.hasErrorsSaveTestCustomMetric(customMetricFormulaError)) {
        return;
      }
      // transform formula to lowercase A and B, and insert * for implied multiplications
      newMonitorCustomMetric.MetricFormula = transformMathFormula(
        newMonitorCustomMetric.MetricFormula,
      );

      // create new Custom Metric if not editing
      if (!createEditCustomMetricID) {
        createMonitorCustomMetric(newMonitorCustomMetric, this.props.session.publisher.ID).then(
          () => {
            this.setState(
              {
                snackbarError: false,
                snackbarMessage: `Successfully created Custom Metric ${newMonitorCustomMetric.Name} with formula ${newMonitorCustomMetric.MetricFormula}. Note ${newMonitorCustomMetric.Name} is now selected.`,
              },
              () => this.fetchMonitorCustomMetricsByPublisherID(true),
            );
            this.handleCustomMetricModalClose(false);
          },
        );
      } else {
        newMonitorCustomMetric.ID = parseInt(createEditCustomMetricID, 10);
        this.setState(
          {
            updatingCustomMetrics: true,
          },
          () => {
            updateMonitorCustomMetric(newMonitorCustomMetric, this.props.session.publisher.ID).then(
              (data) => {
                // get the updated ID here
                const updatedMetric = data[0];
                let updatedMetricID = 0;
                if (updatedMetric) {
                  updatedMetricID = updatedMetric.ID;
                }

                this.setState(
                  {
                    snackbarError: false,
                    snackbarMessage: `Successfully updated Custom Metric ${newMonitorCustomMetric.Name} with formula ${newMonitorCustomMetric.MetricFormula}. Note ${newMonitorCustomMetric.Name} is now selected.`,
                    updatingCustomMetrics: false,
                  },
                  () => this.fetchMonitorCustomMetricsByPublisherID(true, updatedMetricID),
                );
                this.handleCustomMetricModalClose(false);
              },
            );
          },
        );
      }
    };

    handleChangePercentage = (value: string) => {
      const { monitor } = this.state;
      const { AlertThresholds } = monitor;
      const isPercentage = value === percentageEnabledText;

      this.updateMonitorState({
        AlertThresholds: Object.assign(AlertThresholds, {
          IsPercentage: isPercentage,
        }),
      });

      if (isPercentage) {
        this.updateMonitorState({
          AlertTimeframe: EMonitorAlertTimeframe.MonitorAlertTimeframe_Past48H_To_24H,
        });
        // if isPercentage is on and alert_threshold settings is added bulk updated list, need to add AlertTimeframe to bulk update list as well
        if (this.bulkUpdateEnabledFieldsContainFieldAndEnabled('IsPercentage')) {
          const bulkUpdateEnabledFields = cloneDeep(this.state.bulkUpdateEnabledFields);
          if (this.bulkUpdateEnabledFieldsContainField('AlertTimeframe')) {
            bulkUpdateEnabledFields.AlertTimeframe.enabled = true;
          } else {
            bulkUpdateEnabledFields.AlertTimeframe = {
              key: 'AlertTimeframe',
              displayTitle: 'Alert Timeframe',
              genDisplayValue: (): string => {
                if (
                  this.state.monitor.AlertTimeframe ===
                  EMonitorAlertTimeframe.MonitorAlertTimeframe_Past48H_To_24H
                ) {
                  return 'past 48H <-> 24H';
                }
                const selectedItem = this.state.timeframeList.filter(
                  (listItem: IListItem) => listItem.selected,
                );
                if (selectedItem.length) {
                  return selectedItem[0].title;
                }
                return '';
              },
              enabled: true,
            };
          }
          this.setState({
            bulkUpdateEnabledFields,
          });
        }
      } else if (
        !isPercentage &&
        monitor.AlertTimeframe === EMonitorAlertTimeframe.MonitorAlertTimeframe_Past48H_To_24H
      ) {
        // If we previously had a percentage, then we need to set the timeframe back to the default
        this.updateMonitorState({
          AlertTimeframe: EMonitorAlertTimeframe.MonitorAlertTimeframe_2H,
        });
      }
    };

    handleOpenCustomMetricDialog = (customMetricID: string) => {
      const { monitor, createEditCustomMetricAList, createEditCustomMetricBList } = this.state;

      const customMetrics = monitor.monitorCustomMetrics;
      const selectedCustomMetric = monitor.monitorCustomMetrics.find(
        (customMetric: IMonitorCustomMetric) => customMetric.ID.toString() === customMetricID,
      );

      // create NEW custom Metric
      let createEditCustomMetricName = '';
      let createEditCustomMetricFormula = '';

      // if editing existing, populate values
      if (selectedCustomMetric) {
        createEditCustomMetricName = selectedCustomMetric.Name;
        createEditCustomMetricFormula = customMetrics
          .filter((customMetric) => customMetric.ID === Number(customMetricID))[0]
          .MetricFormula.toLocaleLowerCase();
        if (selectedCustomMetric.CustomMetricA) {
          createEditCustomMetricAList[selectedCustomMetric.CustomMetricA].selected = true;
        }
        if (selectedCustomMetric.CustomMetricB) {
          createEditCustomMetricBList[selectedCustomMetric.CustomMetricB].selected = true;
        }
      }

      this.setState({
        createEditCustomMetricID: customMetricID,
        createEditCustomMetricName,
        createEditCustomMetricAList,
        createEditCustomMetricBList,
        createEditCustomMetricFormula,
        openCustomMetricCreateEditDialog: true,
        openCustomMetricTable: false,
      });
    };

    snackbarClose = () => {
      this.setState({
        snackbarMessage: '',
        snackbarError: false,
      });
    };

    hasErrorsSaveTestCustomMetric = (customMetricFormulaError: string) => {
      if (customMetricFormulaError) {
        this.setState({
          snackbarMessage: `Please enter a valid formula before testing and testing Custom Metric: ${customMetricFormulaError}`,
          snackbarError: true,
        });
        return true;
      }
      const customMetricValidationErrors = validatorFactory(customMetricValidatorSetting)(
        this.state,
      );
      if (hasErrors(customMetricValidationErrors)) {
        const errorText = Object.values(customMetricValidationErrors)
          .filter((value) => value.length)
          .join('. ');

        this.setState({
          snackbarMessage: `Please fix errors before testing and saving customMetric: ${errorText}`,
          snackbarError: true,
        });
        return true;
      }

      return false;
    };

    getTargetedObjects = (targetedObjectType: EMonitorObjectType): string => {
      const {
        campaignList,
        bidderGroupList,
        channelGroupList,
        bidderList,
        channelList,
        demandSourceList,
        networkList,
      } = this.state;
      switch (targetedObjectType) {
        case EMonitorObjectType.MonitorObjectType_UNKNOWN:
          return '';
        case EMonitorObjectType.MonitorObjectType_BIDDER:
          return (FindSelectedFromMenuList(bidderList) || ['']).join(',');
        case EMonitorObjectType.MonitorObjectType_SITE:
          return (FindSelectedFromMenuList(channelList) || ['']).join(',');
        case EMonitorObjectType.MonitorObjectType_DEMAND_SOURCE:
          const demandSource = FindSelectedFromMenuList(demandSourceList) || [''];
          if (demandSource.length > 0 && demandSource[0] !== '') {
            return demandSource
              .map(
                (singleDemandSource: string) =>
                  this.props.monitor.PublisherID + '_' + singleDemandSource,
              )
              .join(',');
          }
          break;
        case EMonitorObjectType.MonitorObjectType_BIDDER_GROUP:
          return (FindSelectedFromMenuList(bidderGroupList) || [''])[0];
        case EMonitorObjectType.MonitorObjectType_CHANNEL_GROUP:
          return (FindSelectedFromMenuList(channelGroupList) || [''])[0];
        case EMonitorObjectType.MonitorObjectType_PUBLISHER:
          return this.props.session.publisher.ID;
        case EMonitorObjectType.MonitorObjectType_CAMPAIGN:
        case EMonitorObjectType.MonitorObjectType_CHECKPOINT:
          return (FindSelectedFromMenuList(campaignList) || ['']).join(',');
        case EMonitorObjectType.MonitorObjectType_NETWORK:
          return (FindSelectedFromMenuList(networkList) || ['']).join(',');
      }
      return '';
    };

    checkBeforeSave = (checkThresholds: boolean = true): string | undefined => {
      const { monitor } = this.state;
      const { bulkUpdateIDs, allMonitors } = this.props;
      const bulkUpdateEnabled = !!bulkUpdateIDs && bulkUpdateIDs.length > 0;
      if (
        monitor.ThresholdComputation ===
        EMonitorThresholdComputationType.MonitorThresholdComputationType_AVG
      ) {
        if (!checkThatPeriodAIsWithinPeriodB(monitor.AveragePeriod, monitor.AlertTimeframe)) {
          return 'Average period not within alert timeframe';
        }
      }

      // no need to enforce object targeted selection in bulk update mode
      if (
        !bulkUpdateEnabled &&
        monitor.EnableTargetAllActive === EBool.EBool_FALSE &&
        (monitor.TargetedObject === undefined || monitor.TargetedObject === '')
      ) {
        return 'No object targeted';
      }

      // if Defined Metric is selected but not a Custom, or if Custom is selected but not Defined
      const isMetricNotSelected =
        monitor.TargetedMetric === undefined ||
        monitor.TargetedMetric === 0 ||
        (monitor.TargetedMetric === 64 &&
          (monitor.MonitorCustomMetricID === 0 || monitor.MonitorCustomMetricID === undefined));

      // no need to enforce metrics selection in bulk update mode
      if (!bulkUpdateEnabled && isMetricNotSelected) {
        return 'No metrics targeted';
      }

      // ensure Monitor Name is Unique
      for (const savedMonitor of allMonitors) {
        if (
          monitor.Name.toLowerCase() === savedMonitor.Name.toLowerCase() &&
          monitor.ID !== savedMonitor.ID
        ) {
          return 'Please input a unique Monitor Name';
        }
      }

      const compareReversed =
        monitor.MetricDirection === EMonitorMetricDirection.MonitorMetricDirection_UNDER;
      const compareDir =
        monitor.MetricDirection === EMonitorMetricDirection.MonitorMetricDirection_UNDER
          ? 'less than'
          : 'greater than';

      if (checkThresholds) {
        if (monitor.AlertThresholds.WarningThreshold !== -1) {
          if (
            !compareThresholds(
              monitor.AlertThresholds.AlertThreshold as number,
              monitor.AlertThresholds.WarningThreshold as number,
              compareReversed,
            )
          ) {
            return 'Alert threshold must be ' + compareDir + ' Warning threshold';
          }

          if (
            !compareThresholds(
              monitor.AlertThresholds.WarningThreshold as number,
              monitor.AlertThresholds.WarningRecoveryThreshold as number,
              compareReversed,
            )
          ) {
            return 'Warning threshold must be ' + compareDir + ' Warning Resolution threshold';
          }
          if (
            !compareThresholds(
              monitor.AlertThresholds.AlertRecoveryThreshold as number,
              monitor.AlertThresholds.WarningRecoveryThreshold as number,
              compareReversed,
            )
          ) {
            return (
              'Alert Resolution threshold must be ' + compareDir + ' Warning Resolution threshold'
            );
          }
        }

        if (
          !compareThresholds(
            monitor.AlertThresholds.AlertThreshold as number,
            monitor.AlertThresholds.AlertRecoveryThreshold as number,
            compareReversed,
          )
        ) {
          return 'Alert threshold must be ' + compareDir + ' Alert Resolution threshold';
        }
      }

      return undefined;
    };

    renderObjectTargeting = () => {
      const {
        bidderGroupList,
        bidderList,
        campaignList,
        channelGroupList,
        channelList,
        demandSourceList,
        monitor,
        objectTypeList,
        networkList,
      } = this.state;

      let selectedObject = EMonitorObjectType.MonitorObjectType_UNKNOWN;
      for (const objectTypeListElement of Object.keys(objectTypeList)) {
        if (objectTypeList[objectTypeListElement].selected) {
          selectedObject = +objectTypeListElement as any as EMonitorObjectType;
          break;
        }
      }

      if (selectedObject === EMonitorObjectType.MonitorObjectType_SITE) {
        return (
          <Grid item style={{ width: '300px', marginTop: '5px', marginBottom: '5px' }}>
            <MaterialSearchDropdownMulti
              width='300px'
              fontSize='16px'
              menuTitle='Channels'
              selectLimit={20}
              menuTitleOverride='Select up to 20 Channels'
              list={channelList}
              enableMultiSelect={true}
              onChange={(list: IMenuList) => {
                this.setState({
                  channelList: list,
                });
              }}
              handleMenuAcceptClick={() => {
                const TargetedObject = this.getTargetedObjects(monitor.TargetedObjectType);
                this.updateMonitorState({
                  TargetedObject,
                });
              }}
              maxHeight={325}
              showPrefixID
            />
          </Grid>
        );
      } else if (selectedObject === EMonitorObjectType.MonitorObjectType_CHANNEL_GROUP) {
        return (
          <Grid item style={{ width: '300px', marginTop: '5px', marginBottom: '5px' }}>
            <MaterialSearchDropdownMulti
              width='300px'
              fontSize='16px'
              menuTitle='Channel Group'
              list={channelGroupList}
              enableMultiSelect={false}
              onChange={(list: IMenuList) => {
                this.setState({
                  channelGroupList: list,
                });
              }}
              handleMenuAcceptClick={() => {
                const TargetedObject = this.getTargetedObjects(monitor.TargetedObjectType);
                this.updateMonitorState({
                  TargetedObject,
                });
              }}
              maxHeight={325}
              showPrefixID
            />
          </Grid>
        );
      } else if (selectedObject === EMonitorObjectType.MonitorObjectType_BIDDER) {
        return (
          <Grid item style={{ width: '300px', marginTop: '5px', marginBottom: '5px' }}>
            <MaterialSearchDropdownMulti
              width='300px'
              fontSize='16px'
              enableMultiSelect={true}
              selectLimit={20}
              menuTitleOverride='Select up to 20 Bidders'
              menuTitle='Bidders'
              list={bidderList}
              onChange={(list: IMenuList) => {
                this.setState({
                  bidderList: list,
                });
              }}
              handleMenuAcceptClick={() => {
                const TargetedObject = this.getTargetedObjects(monitor.TargetedObjectType);
                this.updateMonitorState({
                  TargetedObject,
                });
              }}
              maxHeight={325}
              quickFilterOptions={activeQuickFilterOptions}
              overrideActiveResourceFilter={ActiveResourceFilter.Active}
              showPrefixID
            />
          </Grid>
        );
      } else if (selectedObject === EMonitorObjectType.MonitorObjectType_DEMAND_SOURCE) {
        return (
          <Grid item style={{ width: '300px', marginTop: '5px', marginBottom: '5px' }}>
            <MaterialSearchDropdownMulti
              width='300px'
              fontSize='16px'
              menuTitle='Demand Source'
              list={demandSourceList}
              selectLimit={20}
              menuTitleOverride='Select up to 20 Demand Sources'
              enableMultiSelect={true}
              onChange={(list: IMenuList) => {
                this.setState({
                  demandSourceList: list,
                });
              }}
              handleMenuAcceptClick={() => {
                const TargetedObject = this.getTargetedObjects(monitor.TargetedObjectType);
                this.updateMonitorState({
                  TargetedObject,
                });
              }}
              maxHeight={325}
              showPrefixID
            />
          </Grid>
        );
      } else if (selectedObject === EMonitorObjectType.MonitorObjectType_BIDDER_GROUP) {
        return (
          <Grid item style={{ width: '300px', marginTop: '5px', marginBottom: '5px' }}>
            <MaterialSearchDropdownMulti
              width='300px'
              fontSize='16px'
              menuTitle='Bidder Group'
              list={bidderGroupList}
              enableMultiSelect={false}
              onChange={(list: IMenuList) => {
                this.setState({
                  bidderGroupList: list,
                });
              }}
              handleMenuAcceptClick={() => {
                const TargetedObject = this.getTargetedObjects(monitor.TargetedObjectType);
                this.updateMonitorState({
                  TargetedObject,
                });
              }}
              maxHeight={325}
              showPrefixID
            />
          </Grid>
        );
      } else if (
        selectedObject === EMonitorObjectType.MonitorObjectType_CAMPAIGN ||
        selectedObject === EMonitorObjectType.MonitorObjectType_CHECKPOINT
      ) {
        return (
          <Grid item style={{ width: '300px', marginTop: '5px', marginBottom: '5px' }}>
            <MaterialSearchDropdownMulti
              width='300px'
              fontSize='16px'
              enableMultiSelect={true}
              selectLimit={20}
              menuTitleOverride='Select up to 20 Campaigns'
              menuTitle='Campaigns'
              list={campaignList}
              onChange={(list: IMenuList) => {
                this.setState({
                  campaignList: list,
                });
              }}
              handleMenuAcceptClick={() => {
                const TargetedObject = this.getTargetedObjects(monitor.TargetedObjectType);
                this.updateMonitorState({
                  TargetedObject,
                });
              }}
              maxHeight={325}
              showPrefixID
            />
          </Grid>
        );
      } else if (selectedObject === EMonitorObjectType.MonitorObjectType_NETWORK) {
        return (
          <Grid item style={{ width: '300px', marginTop: '5px', marginBottom: '5px' }}>
            <MaterialSearchDropdownMulti
              width='300px'
              fontSize='16px'
              enableMultiSelect={true}
              selectLimit={20}
              menuTitleOverride='Select up to 20 Networks'
              menuTitle='Networks'
              list={networkList}
              onChange={(list: IMenuList) => {
                this.setState({
                  networkList: list,
                });
              }}
              handleMenuAcceptClick={() => {
                const TargetedObject = this.getTargetedObjects(monitor.TargetedObjectType);
                this.updateMonitorState({
                  TargetedObject,
                });
              }}
              maxHeight={325}
              showPrefixID
            />
          </Grid>
        );
      } else if (selectedObject === EMonitorObjectType.MonitorObjectType_PUBLISHER) {
        return (
          <Grid item style={{ width: '300px', marginTop: '5px', marginBottom: '5px' }}>
            {this.props.session.publisher.Name}
          </Grid>
        );
      }
      return <p>Not implemented yet</p>;
    };

    renderCustomRow = (
      customElement: ReactElement,
      customLabel: string,
      fields: string[],
      bulkUpdateItems: IBulkUpdateItem[],
    ) => {
      const { classes, bulkUpdateIDs } = this.props;
      return () => {
        return (
          <Grid item style={{ width: '100%' }}>
            <Grid container direction='row' justify='flex-start' alignItems='center' spacing={1}>
              <Grid item xs={3}>
                <Grid
                  container
                  direction='row'
                  justify='flex-start'
                  alignItems='center'
                  spacing={0}
                >
                  {!!bulkUpdateIDs && !!fields.length && bulkUpdateIDs.length > 0 && (
                    <Grid item>
                      <Checkbox
                        className={classes.checkbox}
                        checked={this.checkIfRowIsMarked(fields)}
                        onChange={() => this.handleChangeMarked(bulkUpdateItems)}
                      />
                    </Grid>
                  )}
                  <Grid item>
                    <Typography className={classes.insideAccordionText}>{customLabel}</Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={9}>
                {customElement}
              </Grid>
            </Grid>
          </Grid>
        );
      };
    };

    renderMetricDefinition = () => {
      const { monitor, objectTypeList } = this.state;
      const { AlertThresholds } = monitor;
      const objectList = Object.keys(objectTypeList).reduce(
        (res, key) => Object.assign(res, { [key]: objectTypeList[key] }),
        {},
      );
      return (
        <div>
          {/* Object Type*/}
          {this.renderCustomRow(
            <Cols style={{ height: '50px', alignItems: 'center' }}>
              <Col>
                <MaterialSearchDropdownMulti
                  enableMultiSelect={false}
                  getValueFromSearchElement={(src: IListItem) => src.title}
                  fontSize='16px'
                  fontColor='black'
                  width='300px'
                  menuTitle='Object Type'
                  list={objectList}
                  onChange={(list: IMenuList) => {
                    this.setState(
                      {
                        objectTypeList: list,
                      },
                      () => {
                        // make sure that we change the toggles that are reliant on object type
                        const targetedObjectType: EMonitorObjectType = +(FindSelectedFromMenuList(
                          list,
                        ) || [EMonitorObjectType.MonitorObjectType_UNKNOWN])[0];
                        this.updateMonitorState({
                          TargetedObjectType: targetedObjectType,
                          monitorDefinedMetricsList: generateMonitorMetricMenuList(
                            false,
                            undefined,
                            undefined,
                            monitor.TargetedObjectType,
                          ),
                          TargetedMetric: 0,
                          TargetedObject: this.getTargetedObjects(targetedObjectType),
                          EnableAutoDisable: this.isEnableAutoDisableAllowed(targetedObjectType)
                            ? this.state.monitor.EnableAutoDisable
                            : EBool.EBool_FALSE,
                          EnableAcknowledgeAlerts: this.isEnableAutoDisableAllowed(
                            targetedObjectType,
                          )
                            ? this.state.monitor.EnableAcknowledgeAlerts
                            : EBool.EBool_FALSE,
                          EnableTargetAllActive: this.isEnableTargetAllActiveAllowed(
                            targetedObjectType,
                          )
                            ? this.state.monitor.EnableTargetAllActive
                            : EBool.EBool_FALSE,
                          MonitorType: this.isMultiMonitorTypeAllowed(targetedObjectType)
                            ? this.state.monitor.MonitorType
                            : EMonitorType.MonitorType_SINGLE,
                        });
                      },
                    );
                  }}
                  handleMenuAcceptClick={() => null}
                />
              </Col>
            </Cols>,
            'Object Type',
            ['TargetedObjectType'],
            [
              {
                key: 'TargetedObjectType',
                displayTitle: 'Object Type',
                genDisplayValue: () => '' + this.state.monitor.TargetedObjectType,
                enabled: true,
              },
            ],
          )()}

          {/* EnableTargetAllActive Selection*/}
          {this.isEnableTargetAllActiveAllowed(monitor.TargetedObjectType) && (
            <Grid item style={{ height: '50px' }}>
              <Grid container direction='row' justify='flex-start' alignItems='center'>
                {this.renderCustomRow(
                  <Grid item style={{ width: '300px', marginTop: '5px', marginBottom: '5px' }}>
                    <Grid item style={{ marginLeft: '6px' }}>
                      <PillSwitcher
                        currentText={
                          monitor.EnableTargetAllActive === EBool.EBool_TRUE
                            ? allActiveEnableTargetAll
                            : customEnableTargetAll
                        }
                        pills={ENABLE_TARGET_ALL_ACTIVE_PILLS}
                        customStyle={{ width: '250px', height: '40px', padding: '10px' }}
                        onChange={(value: string) => {
                          let EnableTargetAllActive = EBool.EBool_TRUE;
                          if (value === customEnableTargetAll) {
                            EnableTargetAllActive = EBool.EBool_FALSE;
                          }
                          this.updateMonitorState({
                            EnableTargetAllActive,
                          });
                        }}
                      />
                    </Grid>
                  </Grid>,
                  'Object Targeting',
                  ['EnableTargetAllActive'],
                  [
                    {
                      key: 'EnableTargetAllActive',
                      displayTitle: 'Object Targeting',
                      genDisplayValue: () =>
                        this.state.monitor.EnableTargetAllActive === EBool.EBool_TRUE
                          ? 'All Active'
                          : 'Custom',
                      enabled: true,
                    },
                  ],
                )()}
              </Grid>
            </Grid>
          )}

          {/* Object Targeting*/}
          {monitor.EnableTargetAllActive === EBool.EBool_FALSE && (
            <Grid item style={{ height: '50px', marginTop: 10 }}>
              <Grid container direction='row' justify='flex-start' alignItems='center'>
                {this.renderCustomRow(
                  this.renderObjectTargeting(),
                  this.isEnableTargetAllActiveAllowed(monitor.TargetedObjectType)
                    ? ''
                    : 'Object Targeting',
                  ['TargetedObject'],
                  [
                    {
                      key: 'TargetedObject',
                      displayTitle: 'Target Object',
                      genDisplayValue: () =>
                        this.getTargetedObjects(this.state.monitor.TargetedObjectType),
                      enabled: true,
                    },
                  ],
                )()}
              </Grid>
            </Grid>
          )}

          {/* Metric Type Selection*/}
          {!isMonitorObjectTypeWithoutCustomMetricType(monitor.TargetedObjectType) && (
            <Grid item style={{ height: '50px' }}>
              <Grid container direction='row' justify='flex-start' alignItems='center'>
                {this.renderCustomRow(
                  <Grid item style={{ width: '300px', marginTop: '5px', marginBottom: '5px' }}>
                    <Grid item style={{ marginLeft: '6px' }}>
                      <PillSwitcher
                        // disabled={readOnly}
                        currentText={monitorTargetedMetricConditionTypeToString(
                          monitor.targetedMetricType,
                        )}
                        pills={MONITOR_TARGETED_METRIC_TYPE_PILLS}
                        customStyle={{ width: '250px', height: '40px', padding: '10px' }}
                        onChange={(value: string) => {
                          let targetedMetricType = TargetedMetricConditionCustom;
                          if (value === 'Defined Metric') {
                            targetedMetricType = TargetedMetricConditionSingle;
                          }
                          this.setState(
                            {
                              debugValue: -1,
                              maxMinValue: {} as IMaxMinMonitorValue,
                            },
                            () => {
                              this.updateMonitorState({
                                targetedMetricType,
                              });
                            },
                          );
                        }}
                      />
                    </Grid>
                  </Grid>,
                  'Metric Type',
                  [],
                  [],
                )()}
              </Grid>
            </Grid>
          )}

          {/* Metric*/}
          <Grid item>
            <Grid
              container
              direction='row'
              justify='flex-start'
              alignItems='center'
              style={{ marginTop: '15px' }}
            >
              {monitor.targetedMetricType === TargetedMetricConditionSingle
                ? this.renderCustomRow(
                    <Grid item style={{ width: '300px', marginTop: '5px', marginBottom: '5px' }}>
                      <MaterialSearchDropdownMulti
                        width='300px'
                        enableMultiSelect={false}
                        getValueFromSearchElement={(src: IListItem) => src.title}
                        fontSize='16px'
                        fontColor='black'
                        menuTitle='Defined Metrics'
                        list={monitor.monitorDefinedMetricsList}
                        handleMenuAcceptClick={() => null}
                        onChange={(monitorDefinedMetricsList: IMenuList) => {
                          const TargetedMetric =
                            getSelectedMetricIDFromMenuList(monitorDefinedMetricsList);
                          let ThresholdComputation = 0 as EMonitorThresholdComputationType;

                          const isMonitorMetricOnlyValueAlertThreshold =
                            isMetricOnlyValueAlertThreshold(TargetedMetric);
                          const isMonitorMetricWithoutTimeFrame =
                            isMetricWithoutTimeframe(TargetedMetric);

                          const isRateMetric = !!ELiveDataTargetedRateMetrics[TargetedMetric];
                          const isAvgMetric = !!ELiveDataTargetedAvgMetrics[TargetedMetric];
                          if (isRateMetric) {
                            // if a Rate Metric is selected (eg. Bid Error Rate, Fill Rate) only show percentage in metric option
                            ThresholdComputation =
                              EMonitorThresholdComputationType.MonitorThresholdComputationType_PERCENTAGE;
                          } else if (isAvgMetric) {
                            // if a avg Metric is selected only show avg in metric option
                            ThresholdComputation =
                              EMonitorThresholdComputationType.MonitorThresholdComputationType_AVG;
                          }
                          this.setState(
                            {
                              thresholdComputationTypeList: genThresholdComputationTypeList(
                                ThresholdComputation,
                                isRateMetric,
                                isAvgMetric,
                              ),
                              timeframeList: genTimeframeList(
                                this.state.monitor.AlertTimeframe,
                                isMetricWithoutTimeframe(TargetedMetric),
                              ),
                            },
                            () => {
                              // set Monitor Custom Metric ID to 0 if using a defined metric and clear custom metric list
                              this.updateMonitorState({
                                MonitorCustomMetricID: 0,
                                monitorDefinedMetricsList,
                                TargetedMetric,
                                ThresholdComputation,
                                monitorCustomMetricsList: generateMonitorCustomMetricList(
                                  monitor.monitorCustomMetrics,
                                ),
                                AlertTimeframe: isMonitorMetricWithoutTimeFrame
                                  ? EMonitorAlertTimeframe.MonitorAlertTimeframe_NoTimeframe
                                  : monitor.AlertTimeframe,
                                AlertThresholds: Object.assign(AlertThresholds, {
                                  IsPercentage: isMonitorMetricOnlyValueAlertThreshold
                                    ? false
                                    : AlertThresholds.IsPercentage,
                                }),
                              });
                            },
                          );
                        }}
                      />
                    </Grid>,
                    'Targeted Metric',
                    ['TargetedMetric'],
                    [
                      {
                        key: 'TargetedMetric',
                        displayTitle: 'Target Metric',
                        genDisplayValue: () => ELiveDataMetrics[this.state.monitor.TargetedMetric],
                        enabled: true,
                      },
                    ],
                  )()
                : this.renderAllCustomMetricsDialog()}
            </Grid>
          </Grid>
        </div>
      );
    };

    renderAllCustomMetricsDialog = () => {
      const { monitor, openCustomMetricTable } = this.state;
      const { monitorCustomMetrics } = monitor;

      return (
        <React.Fragment>
          {this.renderCustomRow(
            <Grid
              item
              style={{ width: '300px', marginTop: '5px', marginBottom: '5px', marginLeft: '5px' }}
            >
              <MaterialSearchDropdownMulti
                enableMultiSelect={false}
                getValueFromSearchElement={(src: IListItem) => src.title}
                fontSize='16px'
                fontColor='black'
                menuTitle='Custom Metric'
                list={monitor.monitorCustomMetricsList}
                handleMenuAcceptClick={() => null}
                onChange={(monitorCustomMetricsList: IMenuList) => {
                  // set monitor Targeted Metric to METRICS_IDENTIFIER_CUSTOM_METRIC, and ThresholdComputation to SUM if selecting a custom metric, and reset defined metrics menu list
                  const MonitorCustomMetric = getSelectedMonitorCustomMetricFromList(
                    monitorCustomMetricsList,
                    monitorCustomMetrics,
                  );
                  this.updateMonitorState({
                    ThresholdComputation:
                      EMonitorThresholdComputationType.MonitorThresholdComputationType_SUM,
                    TargetedMetric: ELiveDataMetrics.METRICS_IDENTIFIER_CUSTOM_METRIC,
                    monitorCustomMetricsList,
                    MonitorCustomMetricID: MonitorCustomMetric.ID,
                    MonitorCustomMetric,
                    monitorDefinedMetricsList: generateMonitorMetricMenuList(
                      false,
                      undefined,
                      undefined,
                      monitor.TargetedObjectType,
                    ),
                  });
                }}
              />
            </Grid>,
            'Targeted Metric',
            ['MonitorCustomMetricID'],
            [
              {
                key: 'MonitorCustomMetricID',
                displayTitle: 'Custom Metric',
                genDisplayValue: () => {
                  // retrieve the name of the custom metric and return it
                  let metricName = 'Custom Metric';
                  Object.values(monitor.monitorCustomMetricsList).forEach((listItem) => {
                    if (listItem.ID === String(monitor.MonitorCustomMetricID)) {
                      metricName = listItem.title;
                    }
                  });
                  return metricName;
                },
                enabled: true,
              },
            ],
          )()}

          {this.renderCustomRow(
            <Grid
              item
              style={{ width: '300px', marginTop: '5px', marginBottom: '5px', marginLeft: '5px' }}
            >
              <ModelSecondaryButton
                onClick={() => this.setState({ openCustomMetricTable: true })}
                // disabled={!writeAuthorization.isAuthorized}
              >
                + Add / Edit Custom Metric
              </ModelSecondaryButton>
            </Grid>,
            '',
            [],
            [],
          )()}

          {openCustomMetricTable ? (
            <Dialog
              fullWidth
              maxWidth='md'
              keepMounted
              open={openCustomMetricTable}
              onClose={() => this.setState({ openCustomMetricTable: false })}
            >
              {this.renderCustomMetricListTableDialog()}
              <DialogActions>
                <Button
                  autoFocus
                  color='primary'
                  onClick={() => this.handleCustomMetricModalClose(false)}
                >
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          ) : (
            this.renderCreateEditCustomMetricDialog()
          )}
        </React.Fragment>
      );
    };

    renderCreateEditCustomMetricDialog = () => {
      const { classes } = this.props;
      const {
        createEditCustomMetricID,
        createEditCustomMetricName,
        createEditCustomMetricFormula,

        openCustomMetricCreateEditDialog,
        createEditTestCustomMetricTimeframe,
        createEditTestTimeFrameList,
        customMetricFormulaError,

        customMetricTestDebugVal,
        customMetricTestMaxMinVal,

        monitorValuesLoading,
      } = this.state;
      let { createEditCustomMetricAList, createEditCustomMetricBList } = this.state;
      // const writeAuthorization = IS_AUTHORIZED(['write_bidder'], user.user);

      // don't allow same metric to be selected between lists
      const selectedMetricFromListA = getSelectedMetricIDFromMenuList(createEditCustomMetricAList);
      const selectedMetricFromListB = getSelectedMetricIDFromMenuList(createEditCustomMetricBList);
      if (selectedMetricFromListB) {
        createEditCustomMetricAList = generateMonitorMetricMenuList(
          true,
          selectedMetricFromListA,
          selectedMetricFromListB,
        );
      }
      if (selectedMetricFromListA) {
        createEditCustomMetricBList = generateMonitorMetricMenuList(
          true,
          selectedMetricFromListB,
          selectedMetricFromListA,
        );
      }

      return openCustomMetricCreateEditDialog ? (
        <DialogWidth730
          fullWidth
          maxWidth='md'
          keepMounted
          open={openCustomMetricCreateEditDialog}
          onClose={() => this.handleCustomMetricModalClose(false)}
        >
          <Grid item style={{ height: '560px' }}>
            <Typography
              className={classes.parameterHeaders}
              style={{ marginLeft: 50, marginTop: 30, fontSize: 18, fontWeight: 'bold' }}
            >
              {!createEditCustomMetricID ? 'New Custom Metric' : 'Edit Custom Metric'}
            </Typography>

            <Divider style={{ margin: 10, height: 1, color: 'black' }} />

            <Grid container direction='column' justify='flex-start' alignItems='flex-start'>
              <Grid
                container
                item
                direction='row'
                style={{ marginLeft: 50, marginTop: 5, marginBottom: 10 }}
              >
                <Grid item style={{ marginRight: 70, marginTop: 5 }}>
                  <Typography
                    className={classes.headingCategorySubtitle}
                    style={{ fontSize: '16px' }}
                  >
                    Name
                  </Typography>
                </Grid>
                <Grid item style={{ marginLeft: 30, marginBottom: 5 }}>
                  <TextField
                    name='createEditCustomMetricName'
                    placeholder='Enter name'
                    value={createEditCustomMetricName}
                    onChange={this.handleChange}
                    style={{ width: '300px' }}
                    color='primary'
                  />
                </Grid>
              </Grid>

              <Grid
                container
                item
                direction='row'
                alignItems='baseline'
                style={{ marginLeft: 50, marginTop: 5, marginBottom: 10 }}
              >
                <Grid item style={{ marginRight: 70 }}>
                  <Typography
                    className={classes.headingCategorySubtitle}
                    style={{ fontSize: '16px' }}
                  >
                    METRIC A
                  </Typography>
                </Grid>
                <Grid item>
                  <MaterialSearchDropdownMulti
                    width='300px'
                    enableMultiSelect={false}
                    getValueFromSearchElement={(src: IListItem) => src.title}
                    fontSize='16px'
                    fontColor='black'
                    menuTitle='Metric A'
                    list={createEditCustomMetricAList}
                    handleMenuAcceptClick={() => null}
                    onChange={(createEditCustomMetricAList: IMenuList) => {
                      this.setState({
                        createEditCustomMetricAList,
                      });
                    }}
                  />
                </Grid>
              </Grid>

              <Grid
                container
                item
                direction='row'
                alignItems='baseline'
                style={{ marginLeft: 50, marginTop: 5, marginBottom: 10 }}
              >
                <Grid item style={{ marginRight: 70 }}>
                  <Typography
                    className={classes.headingCategorySubtitle}
                    style={{ fontSize: '16px' }}
                  >
                    METRIC B
                  </Typography>
                </Grid>
                <Grid item>
                  <MaterialSearchDropdownMulti
                    width='300px'
                    enableMultiSelect={false}
                    getValueFromSearchElement={(src: IListItem) => src.title}
                    fontSize='16px'
                    fontColor='black'
                    menuTitle='Metric B'
                    list={createEditCustomMetricBList}
                    handleMenuAcceptClick={() => null}
                    onChange={(createEditCustomMetricBList: IMenuList) => {
                      this.setState({
                        createEditCustomMetricBList,
                      });
                    }}
                  />
                </Grid>
              </Grid>

              <Grid
                container
                item
                direction='row'
                alignItems='baseline'
                style={{ marginLeft: 50, marginTop: 5, marginBottom: 10 }}
              >
                <Grid item style={{ marginRight: 70 }}>
                  <Typography
                    className={classes.headingCategorySubtitle}
                    style={{ fontSize: '16px' }}
                  >
                    Formula
                  </Typography>
                </Grid>
                <Grid item>
                  <MathExpressionEditor
                    value={createEditCustomMetricFormula}
                    highlight={(code) => highlight(code, languages.elm, 'elm')}
                    padding={8}
                    maxLength={2000}
                    onValueChange={(createEditCustomMetricFormula) => {
                      this.setState({ createEditCustomMetricFormula });
                    }}
                    textStyle={{
                      background: 'aliceblue',
                      borderRadius: '5px',
                      opacity: '1',
                      marginBottom: '5px',
                    }}
                    width='330px'
                    wikiMsgHidden={false}
                    // disabled={readOnly}
                    placeholder={'Enter Math Expression using variables "a" and "b"'}
                    getExpressionEditorError={(customMetricFormulaError) => {
                      this.setState({ customMetricFormulaError });
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
            {/* row container ends here*/}

            <Grid
              container
              item
              direction='column'
              style={{ width: 510, marginLeft: 190, marginTop: 10 }}
            >
              <Grid item container spacing={4}>
                <ModelSecondaryButton
                  style={{ paddingLeft: '6px', marginLeft: '-6px', marginTop: '8px' }}
                  onClick={() => {
                    if (this.hasErrorsSaveTestCustomMetric(customMetricFormulaError)) {
                      return;
                    }
                    this.getValuesForTheseParameters();
                  }}
                >
                  Test Calculation
                </ModelSecondaryButton>
                <Grid item style={{ alignSelf: 'end' }}>
                  during last
                </Grid>
                <Grid item>
                  <Select
                    value={createEditTestCustomMetricTimeframe}
                    onChange={({ target }) => {
                      const newVal = +(target.value as any);
                      this.setState({
                        createEditTestTimeFrameList: genTimeframeList(newVal),
                        createEditTestCustomMetricTimeframe: newVal,
                      });
                    }}
                  >
                    {createEditTestTimeFrameList.map((value: IListItem) => (
                      <MenuItem value={value.ID}>{value.title}</MenuItem>
                    ))}
                  </Select>
                </Grid>
              </Grid>
              {monitorValuesLoading! && <LinearProgress style={{ maxWidth: '120px' }} />}
            </Grid>

            <Grid container item style={{ marginLeft: 175, maxWidth: 500, flexWrap: 'nowrap' }}>
              {/* Current Value*/}
              <Grid item container direction='column' spacing={1} style={{ marginTop: '10px' }}>
                <Grid item style={{ fontWeight: 500 }}>
                  Current Value
                </Grid>
                <Grid item xs={4}>
                  {customMetricTestDebugVal === -1
                    ? ''
                    : NumberWithCommas(customMetricTestDebugVal)}
                </Grid>
              </Grid>
              {/* Min Value*/}
              <Grid item container direction='column' spacing={1} style={{ marginTop: '10px' }}>
                <Grid item style={{ fontWeight: 500 }}>
                  Min Value
                </Grid>
                <Grid item xs={4}>
                  {customMetricTestMaxMinVal.min === -1 ||
                  customMetricTestMaxMinVal.min === undefined
                    ? ''
                    : NumberWithCommas(customMetricTestMaxMinVal.min)}
                </Grid>
              </Grid>
              {/* Max Value*/}
              <Grid item container direction='column' spacing={1} style={{ marginTop: '10px' }}>
                <Grid item style={{ fontWeight: 500 }}>
                  Max Value
                </Grid>
                <Grid item xs={4}>
                  {customMetricTestMaxMinVal.max === -1 ||
                  customMetricTestMaxMinVal.max === undefined
                    ? ''
                    : NumberWithCommas(customMetricTestMaxMinVal.max)}
                </Grid>
              </Grid>
            </Grid>

            <Divider style={{ margin: 10, height: 1, color: 'black' }} />

            <DialogActions style={{ marginRight: 35 }}>
              <Button
                autoFocus
                style={{
                  backgroundColor: getColorTheme('channelBidderPrimaryButton'),
                  color: getColorTheme('channelBidderPrimaryButtonText'),
                }}
                onClick={() => {
                  const newMonitorCustomMetric = {
                    Name: createEditCustomMetricName,
                    CustomMetricA: getSelectedMetricIDFromMenuList(createEditCustomMetricAList),
                    CustomMetricB: getSelectedMetricIDFromMenuList(createEditCustomMetricBList),
                    MetricFormula: createEditCustomMetricFormula.toLocaleLowerCase(),
                    PublisherID: parseInt(this.props.session.publisher.ID, 10),
                  } as IMonitorCustomMetric;

                  this.handleSaveEditCustomMetric(
                    createEditCustomMetricID,
                    newMonitorCustomMetric,
                    customMetricFormulaError,
                  );
                }}
              >
                Save
              </Button>

              <Button
                autoFocus
                color='primary'
                onClick={() => this.handleCustomMetricModalClose(true)}
              >
                Cancel
              </Button>
            </DialogActions>
          </Grid>
        </DialogWidth730>
      ) : // </Grid>
      null;
    };

    renderCustomMetricListTableDialog = () => {
      const { user } = this.props;
      const { updatingCustomMetrics, monitor } = this.state;

      const listTableColumns: IListTableColumn[] = [
        {
          field: 'Name',
          title: 'Custom Metric Name',
          renderType: 'modal3',
          searchable: true,
          maxWidth: '200px',
          cellStyle: { overflow: 'hidden', textAlign: 'center' },
        },
        {
          field: 'MonitorCustomMetricA',
          title: 'Metric A',
          renderType: 'normal',
          searchable: false,
        },
        {
          field: 'MonitorCustomMetricB',
          title: 'Metric B',
          renderType: 'normal',
          searchable: false,
        },
        {
          field: 'MonitorCustomMetricFormula',
          title: 'Metric Formula',
          renderType: 'normal',
          searchable: false,
        },
        { field: 'Actions', title: 'Actions', renderType: 'actions', searchable: false },
      ];

      const listTableData: IMonitorCustomMetricRowData[] = monitor.monitorCustomMetrics.map(
        (customMetric: IMonitorCustomMetric) => {
          const customMetricName = checkUserInfoMasked(user.user)
            ? `demo_site_${customMetric.ID}`
            : customMetric.Name;
          return {
            ID: customMetric.ID.toString(),
            Name: customMetricName,
            MonitorCustomMetricA: ELiveDataMetricsString(
              ELiveDataMetricsKey.get(customMetric.CustomMetricA) as any,
            ),
            MonitorCustomMetricB: ELiveDataMetricsString(
              ELiveDataMetricsKey.get(customMetric.CustomMetricB) as any,
            ),
            MonitorCustomMetricFormula: customMetric.MetricFormula,
          };
        },
      );

      return (
        <Grid item style={{ margin: '20px 15px 5px 15px', width: '97%' }}>
          <ListTable
            title={''}
            columns={listTableColumns}
            data={listTableData}
            isUpdating={updatingCustomMetrics}
            handleSetUpdating={this.handleSetUpdatingCustomMetric}
            handleDeleteItem={(customMetricID: string) =>
              this.handleDeleteCustomMetric(customMetricID, true)
            }
            handleOpenModal3={this.handleOpenCustomMetricDialog}
            modal3GridStyles={{ alignItems: 'center' }}
            fixedEnabled={true}
            renderCustomToolbar={this.renderCustomToolbar}
            pageSize={10}
            // readRoleName={'read_channel'}
            // writeRoleName={'write_channel'}
          />
        </Grid>
      );
    };

    renderCustomToolbar = (props: any): ReactElement => {
      const { classes } = this.props;
      const { updatingCustomMetrics } = this.state;

      const copyProps = {
        ...props,
        searchFieldStyle: { ...props.searchFieldStyle, marginLeft: '-48px', width: '300px' },
      };

      return (
        <Grid item className={classes.toolbarRow}>
          <Grid container direction='row' justify='space-between' alignItems='center'>
            <Grid item>
              <MTableToolbar {...copyProps} />
            </Grid>
            <RowButton
              right={
                <ButtonView
                  onClick={() => {
                    this.setState({
                      openCustomMetricTable: false,
                      openCustomMetricCreateEditDialog: true,
                    });
                  }}
                  text='+ New Custom Metric'
                  active={updatingCustomMetrics}
                />
              }
            />
          </Grid>
        </Grid>
      );
    };

    renderTestValues = () => {
      const { bulkUpdateIDs } = this.props;
      const { debugValue, maxMinValue, monitor, openRecentValue } = this.state;
      const { ThresholdComputation } = monitor;
      const bulkUpdateEnabled = !!bulkUpdateIDs && bulkUpdateIDs.length > 0;
      // only show % symbol for rates
      const showPercentage =
        ThresholdComputation ===
          EMonitorThresholdComputationType.MonitorThresholdComputationType_PERCENTAGE &&
        monitor.targetedMetricType === TargetedMetricConditionSingle;
      let timeframeTxt = '';

      for (const timeframe of this.state.timeframeList) {
        if (timeframe.selected) {
          timeframeTxt = timeframe.title;
          break;
        }
      }

      const bulkUpdateAttributeList = [
        {
          key: 'AlertThreshold',
          displayTitle: 'Alert Threshold',
          genDisplayValue: () => '' + this.state.monitor.AlertThresholds.AlertThreshold,
          enabled: true,
        },
        {
          key: 'WarningThreshold',
          displayTitle: 'Warning Threshold',
          genDisplayValue: () => '' + this.state.monitor.AlertThresholds.WarningThreshold,
          enabled: true,
        },
        {
          key: 'AlertRecoveryThreshold',
          displayTitle: 'Alert Recovery Threshold',
          genDisplayValue: () => '' + this.state.monitor.AlertThresholds.AlertRecoveryThreshold,
          enabled: true,
        },
        {
          key: 'WarningRecoveryThreshold',
          displayTitle: 'Warning Recovery Threshold',
          genDisplayValue: () => '' + this.state.monitor.AlertThresholds.WarningRecoveryThreshold,
          enabled: true,
        },
        {
          key: 'IsPercentage',
          displayTitle: 'Is Percentage',
          genDisplayValue: () => '' + this.state.monitor.AlertThresholds.IsPercentage,
          enabled: true,
        },
        {
          key: 'DisableWarning',
          displayTitle: 'Disable Warning',
          genDisplayValue: () =>
            this.state.monitor.AlertThresholds.WarningThreshold === -1 ? 'True' : 'False',
          enabled: true,
        },
      ];
      if (this.state.monitor.AlertThresholds.IsPercentage) {
        bulkUpdateAttributeList.push({
          key: 'AlertTimeframe',
          displayTitle: 'Alert Timeframe',
          genDisplayValue: (): string => {
            if (
              this.state.monitor.AlertTimeframe ===
              EMonitorAlertTimeframe.MonitorAlertTimeframe_Past48H_To_24H
            ) {
              return 'past 48H <-> 24H';
            }
            const selectedItem = this.state.timeframeList.filter(
              (listItem: IListItem) => listItem.selected,
            );
            if (selectedItem.length) {
              return selectedItem[0].title;
            }
            return '';
          },
          enabled: true,
        });
      }

      return (
        <Grid style={{ marginTop: 10 }}>
          <Grid item onClick={() => this.setState({ openRecentValue: !openRecentValue })}>
            <Grid container>
              <Grid item>
                <Typography style={{ fontSize: 16, fontWeight: 500, cursor: 'pointer' }}>
                  View recent value
                </Typography>
              </Grid>
              <Grid item>
                {openRecentValue ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
              </Grid>
            </Grid>
          </Grid>
          {openRecentValue && (
            <>
              {/* top bar */}
              {monitor.MonitorType === EMonitorType.MonitorType_SINGLE && !bulkUpdateEnabled && (
                <Grid item style={{ paddingBottom: 10, paddingTop: 10 }}>
                  <Grid container direction='row' justify='space-between' alignItems='center'>
                    <Grid item>
                      {`Data displayed for the metric defined from ${
                        monitor.AlertThresholds.IsPercentage
                          ? 'the last 48 to 24 hours'
                          : 'during last'
                      } ${monitor.AlertThresholds.IsPercentage ? '' : timeframeTxt}`}
                    </Grid>
                    <Grid item>
                      <Grid
                        container
                        direction='row'
                        alignItems='center'
                        spacing={1}
                        style={{ cursor: 'pointer' }}
                      >
                        <Grid item>
                          <RefreshIcon
                            style={{ fontWeight: 500, fontSize: 18, color: '#5865E8' }}
                          />
                        </Grid>
                        <Grid
                          item
                          onClick={this.getValuesForTheseParameters}
                          style={{
                            fontWeight: 500,
                            fontSize: 14,
                            color: '#5865E8',
                            marginBottom: 4,
                          }}
                        >
                          Refresh Values
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              )}

              {/* box with values */}
              {monitor.MonitorType === EMonitorType.MonitorType_SINGLE && !bulkUpdateEnabled && (
                <Grid
                  item
                  style={{
                    padding: 20,
                    width: '100%',
                    marginBottom: 10,
                    border: '1px solid #e6e6e6',
                    borderRadius: 4,
                  }}
                >
                  <Grid
                    container
                    direction='row'
                    justify='space-between'
                    alignItems='center'
                    spacing={2}
                  >
                    {/* Current Value*/}
                    <Grid item xs={4}>
                      <Grid container direction='row' alignItems='center'>
                        <Grid item style={{ fontWeight: 500 }} xs={7}>
                          Current Value
                        </Grid>
                        <Grid item xs={4}>
                          {debugValue === -1 ? '' : NumberWithCommas(debugValue)}{' '}
                          {showPercentage && '%'}
                        </Grid>
                      </Grid>
                    </Grid>
                    {/* Min Value*/}
                    <Grid item xs={4}>
                      <Grid container direction='row' alignItems='center'>
                        <Tooltip title='Min and max values are an estimate of the lowest and highest monitor data returned for the selected look back window in the previous 24-48 hours'>
                          <Grid item style={{ fontWeight: 500 }} xs={7}>
                            Min Value
                          </Grid>
                        </Tooltip>
                        <Grid item xs={4}>
                          {maxMinValue.min === -1 || maxMinValue.min === undefined
                            ? ''
                            : NumberWithCommas(maxMinValue.min)}{' '}
                          {showPercentage && '%'}
                        </Grid>
                      </Grid>
                    </Grid>
                    {/* Max Value*/}
                    <Grid item xs={4}>
                      <Grid container direction='row' alignItems='center'>
                        <Tooltip title='Min and max values are an estimate of the lowest and highest monitor data returned for the selected look back window in the previous 24-48 hours'>
                          <Grid item style={{ fontWeight: 500 }} xs={7}>
                            Max Value
                          </Grid>
                        </Tooltip>
                        <Grid item xs={4}>
                          {maxMinValue.max === -1 || maxMinValue.max === undefined
                            ? ''
                            : NumberWithCommas(maxMinValue.max)}{' '}
                          {showPercentage && '%'}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </>
          )}
        </Grid>
      );
    };

    renderAlertThreshold = () => {
      const { bulkUpdateIDs, classes } = this.props;
      const { monitor } = this.state;
      const { AlertThresholds, MetricDirection, TargetedMetric } = monitor;
      const bulkUpdateEnabled = !!bulkUpdateIDs && bulkUpdateIDs.length > 0;
      const iconDir = GetIconDirection(MetricDirection);
      const iconDirRecovery = GetIconDirection(
        MetricDirection === EMonitorMetricDirection.MonitorMetricDirection_UNDER
          ? EMonitorMetricDirection.MonitorMetricDirection_ABOVE
          : EMonitorMetricDirection.MonitorMetricDirection_UNDER,
      ); // == to the opposite of icon dir
      const isMonitorTypeSingle = monitor.MonitorType === EMonitorType.MonitorType_SINGLE;
      const isRateMetric = !!ELiveDataTargetedRateMetrics[TargetedMetric];
      const isMonitorMetricOnlyValueAlertThreshold = isMetricOnlyValueAlertThreshold(
        monitor.TargetedMetric,
      );

      const bulkUpdateKeyList = [
        'AlertThreshold',
        'WarningThreshold',
        'AlertRecoveryThreshold',
        'WarningRecoveryThreshold',
        'IsPercentage',
        'DisableWarning',
      ];
      const bulkUpdateAttributeList = [
        {
          key: 'AlertThreshold',
          displayTitle: 'Alert Threshold',
          genDisplayValue: () => '' + this.state.monitor.AlertThresholds.AlertThreshold,
          enabled: true,
        },
        {
          key: 'WarningThreshold',
          displayTitle: 'Warning Threshold',
          genDisplayValue: () => '' + this.state.monitor.AlertThresholds.WarningThreshold,
          enabled: true,
        },
        {
          key: 'AlertRecoveryThreshold',
          displayTitle: 'Alert Recovery Threshold',
          genDisplayValue: () => '' + this.state.monitor.AlertThresholds.AlertRecoveryThreshold,
          enabled: true,
        },
        {
          key: 'WarningRecoveryThreshold',
          displayTitle: 'Warning Recovery Threshold',
          genDisplayValue: () => '' + this.state.monitor.AlertThresholds.WarningRecoveryThreshold,
          enabled: true,
        },
        {
          key: 'IsPercentage',
          displayTitle: 'Is Percentage',
          genDisplayValue: () => '' + this.state.monitor.AlertThresholds.IsPercentage,
          enabled: true,
        },
        {
          key: 'DisableWarning',
          displayTitle: 'Disable Warning',
          genDisplayValue: () =>
            this.state.monitor.AlertThresholds.WarningThreshold === -1 ? 'True' : 'False',
          enabled: true,
        },
      ];

      if (this.state.monitor.AlertThresholds.IsPercentage) {
        bulkUpdateAttributeList.push({
          key: 'AlertTimeframe',
          displayTitle: 'Alert Timeframe',
          genDisplayValue: (): string => {
            if (
              this.state.monitor.AlertTimeframe ===
              EMonitorAlertTimeframe.MonitorAlertTimeframe_Past48H_To_24H
            ) {
              return 'past 48H <-> 24H';
            }
            const selectedItem = this.state.timeframeList.filter(
              (listItem: IListItem) => listItem.selected,
            );
            if (selectedItem.length) {
              return selectedItem[0].title;
            }
            return '';
          },
          enabled: true,
        });
      }

      return (
        <Grid item style={{ width: '100%' }}>
          {!isMonitorMetricOnlyValueAlertThreshold && (
            <Grid container direction='column'>
              {/* Percentage Switch */}
              <Grid item xs={4}>
                <PillSwitcher
                  currentText={
                    monitor.AlertThresholds.IsPercentage ? percentageEnabledText : valueEnabledText
                  }
                  pills={MONITOR_AS_PERCENTAGE_PILLS}
                  customStyle={{ width: '250px', height: '40px', padding: '10px' }}
                  onChange={this.handleChangePercentage}
                />
              </Grid>
            </Grid>
          )}
          {!bulkUpdateEnabled && isMonitorTypeSingle && this.renderTestValues()}
          {bulkUpdateEnabled && (
            <Grid item style={{ width: '100%', marginTop: '10px' }}>
              <Grid container direction='row' justify='flex-start' alignItems='center' spacing={1}>
                <Grid item xs={3}>
                  <Grid
                    container
                    direction='row'
                    justify='flex-start'
                    alignItems='center'
                    spacing={0}
                  >
                    <Grid item>
                      <Checkbox
                        className={classes.checkbox}
                        checked={this.checkIfRowIsMarked(bulkUpdateKeyList)}
                        onChange={() => this.handleChangeMarked(bulkUpdateAttributeList)}
                      />
                    </Grid>
                    <Grid item>
                      <Typography className={classes.insideAccordionText}>
                        Threshold Settings
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          )}

          {/*  Monitor Logic Blue Box */}
          <Grid
            item
            style={{
              borderRadius: 2,
              backgroundColor: 'rgba(213,216,249,0.28)',
              padding: '2px 12px 2px 8px',
              maxWidth: 510,
            }}
          >
            <Grid container direction='row' alignItems='center'>
              <Grid item>
                <img
                  style={{ marginTop: 4, marginRight: 4, height: 24 }}
                  src='/assets/shared/svg/Activity.svg'
                />
              </Grid>
              <Grid item>
                <Typography style={{ fontSize: 14 }}>
                  Monitor logic triggers alerts based on the threshold values defined below
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          {/* Alert */}
          <Grid container spacing={1} alignItems='center' style={{ marginTop: '10px' }}>
            <Grid container direction='row' justify='flex-start' alignItems='center'>
              <Grid item xs={4}>
                Alert Threshold
              </Grid>
              <Grid item xs={5}>
                {<iconDir.Alert className={classes.thresholdsIcons} />}
                <TextField
                  id='outlined-basic'
                  label=''
                  variant='outlined'
                  InputProps={{
                    className: classes.redBackground,
                    endAdornment:
                      AlertThresholds.IsPercentage || isRateMetric ? (
                        <InputAdornment position='end'>%</InputAdornment>
                      ) : (
                        <span />
                      ),
                  }}
                  onChange={({ target }: React.ChangeEvent<HTMLInputElement>) => {
                    const value = parseFloat(target.value.replace(/,/g, ''));
                    this.updateMonitorState({
                      AlertThresholds: Object.assign(AlertThresholds, {
                        AlertThreshold: isNaN(+value) ? AlertThresholds.AlertThreshold : +value,
                      }),
                    });
                  }}
                  value={AlertThresholds.AlertThreshold.toLocaleString()}
                />
              </Grid>
            </Grid>
          </Grid>
          {/* Warning*/}
          <Grid container spacing={1} alignItems='center' style={{ marginTop: '10px' }}>
            <Grid item xs={4}>
              Warning Threshold
            </Grid>
            <Grid item xs={5}>
              {<iconDir.Warning className={classes.thresholdsIcons} />}
              <TextField
                id='outlined-basic'
                variant='outlined'
                InputProps={{
                  className: classes.yellowBackground,
                  endAdornment:
                    AlertThresholds.IsPercentage || isRateMetric ? (
                      <InputAdornment position='end'>%</InputAdornment>
                    ) : (
                      <span />
                    ),
                }}
                onChange={({ target }: React.ChangeEvent<HTMLInputElement>) => {
                  const value = parseFloat(target.value.replace(/,/g, ''));
                  this.updateMonitorState({
                    AlertThresholds: Object.assign(AlertThresholds, {
                      WarningThreshold: isNaN(+value) ? AlertThresholds.WarningThreshold : +value,
                    }),
                  });
                }}
                value={
                  AlertThresholds.WarningThreshold === -1
                    ? 0
                    : AlertThresholds.WarningThreshold.toLocaleString()
                }
                disabled={AlertThresholds.WarningThreshold === -1}
              />
            </Grid>
          </Grid>
          {/* Alert Recovery*/}
          <Grid container spacing={1} alignItems='center' style={{ marginTop: '10px' }}>
            <Grid item xs={4}>
              Alert Resolution Threshold
            </Grid>
            <Grid item xs={5}>
              {<iconDirRecovery.AlertRecovery className={classes.thresholdsIcons} />}
              <TextField
                id='outlined-basic'
                variant='outlined'
                InputProps={{
                  className: classes.greenBackground,
                  endAdornment:
                    AlertThresholds.IsPercentage || isRateMetric ? (
                      <InputAdornment position='end'>%</InputAdornment>
                    ) : (
                      <span />
                    ),
                }}
                onChange={({ target }: React.ChangeEvent<HTMLInputElement>) => {
                  const value = parseFloat(target.value.replace(/,/g, ''));
                  this.updateMonitorState({
                    AlertThresholds: Object.assign(AlertThresholds, {
                      AlertRecoveryThreshold: isNaN(+value)
                        ? AlertThresholds.AlertRecoveryThreshold
                        : +value,
                    }),
                  });
                }}
                value={AlertThresholds.AlertRecoveryThreshold.toLocaleString()}
              />
            </Grid>
          </Grid>
          {/* Warning Recovery*/}
          <Grid container spacing={1} alignItems='center' style={{ marginTop: '10px' }}>
            <Grid item xs={4}>
              Warning Resolution Threshold
            </Grid>
            <Grid item xs={5}>
              {<iconDirRecovery.WarningRecovery className={classes.thresholdsIcons} />}
              <TextField
                id='outlined-basic'
                variant='outlined'
                onChange={({ target }: React.ChangeEvent<HTMLInputElement>) => {
                  const value = parseFloat(target.value.replace(/,/g, ''));
                  this.updateMonitorState({
                    AlertThresholds: Object.assign(AlertThresholds, {
                      WarningRecoveryThreshold: isNaN(+value)
                        ? AlertThresholds.WarningRecoveryThreshold
                        : +value,
                    }),
                  });
                }}
                value={
                  AlertThresholds.WarningThreshold === -1
                    ? 0
                    : AlertThresholds.WarningRecoveryThreshold.toLocaleString()
                }
                disabled={AlertThresholds.WarningThreshold === -1}
                InputProps={{
                  className: classes.greenBackground,
                  endAdornment:
                    AlertThresholds.IsPercentage || isRateMetric ? (
                      <InputAdornment position='end'>%</InputAdornment>
                    ) : (
                      <span />
                    ),
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      );
    };

    renderAlertCondition = () => {
      const {
        monitor,
        metricDirectionList,
        thresholdComputationTypeList,
        averagePeriodList,
        timeframeList,
      } = this.state;
      const { bulkUpdateIDs, classes } = this.props;
      const { AlertThresholds } = monitor;
      const bulkUpdateEnabled = !!bulkUpdateIDs && bulkUpdateIDs.length > 0;
      const isCustomMetric =
        monitor.TargetedMetric === ELiveDataMetrics.METRICS_IDENTIFIER_CUSTOM_METRIC &&
        monitor.targetedMetricType === TargetedMetricConditionCustom;
      const targetedObjectType = MonitorObjectTypeToString(
        monitor.TargetedObjectType,
      ).toLowerCase();
      const isMonitorTypeSingle = monitor.MonitorType === EMonitorType.MonitorType_SINGLE;

      return (
        <div>
          <Grid item>
            {/* Monitor Type */}
            {bulkUpdateEnabled && (
              <Grid
                container
                direction='row'
                justify='flex-start'
                alignItems='flex-start'
                style={{ marginTop: '10px', marginBottom: '1px' }}
                spacing={4}
              >
                <Grid item xs={3}>
                  <Grid container direction='row'>
                    <Grid item>
                      <Checkbox
                        className={classes.checkbox}
                        checked={this.checkIfRowIsMarked(['MonitorType'])}
                        onChange={() =>
                          this.handleChangeMarked([
                            {
                              key: 'MonitorType',
                              enabled: true,
                              displayTitle: 'Monitor Type',
                              genDisplayValue: (): string =>
                                this.state.monitor.MonitorType === EMonitorType.MonitorType_SINGLE
                                  ? 'Single'
                                  : 'Multi',
                            },
                          ])
                        }
                      />
                    </Grid>
                    <Grid item>
                      <Typography className={classes.insideAccordionText}>Monitor Type</Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={3}>
                  <Grid container direction='row'>
                    <Grid item>
                      <Checkbox
                        className={classes.checkbox}
                        checked={this.checkIfRowIsMarked(['MetricDirection'])}
                        onChange={() =>
                          this.handleChangeMarked([
                            {
                              key: 'MetricDirection',
                              enabled: true,
                              displayTitle: 'Metric Direction',
                              genDisplayValue: (): string => {
                                const selectedKey = Object.keys(
                                  this.state.metricDirectionList,
                                ).filter((key) => this.state.metricDirectionList[key].selected);
                                if (selectedKey.length) {
                                  return this.state.metricDirectionList[selectedKey[0]].title;
                                }
                                return '';
                              },
                            },
                          ])
                        }
                      />
                    </Grid>
                    <Grid item>
                      <Typography className={classes.insideAccordionText}>
                        Metric Direction
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                {monitor.MonitorType === EMonitorType.MonitorType_SINGLE && (
                  <Grid item xs={3}>
                    <Grid container direction='row'>
                      <Grid item>
                        <Checkbox
                          className={classes.checkbox}
                          checked={this.checkIfRowIsMarked(['ThresholdComputation'])}
                          onChange={() =>
                            this.handleChangeMarked([
                              {
                                key: 'ThresholdComputation',
                                enabled: true,
                                displayTitle: 'Threshold Computation',
                                genDisplayValue: (): string => {
                                  const selectedKey = Object.keys(
                                    this.state.thresholdComputationTypeList,
                                  ).filter(
                                    (key) => this.state.thresholdComputationTypeList[key].selected,
                                  );
                                  if (selectedKey.length) {
                                    return this.state.thresholdComputationTypeList[selectedKey[0]]
                                      .title;
                                  }
                                  return '';
                                },
                              },
                            ])
                          }
                        />
                      </Grid>
                      <Grid item>
                        <Typography className={classes.insideAccordionText}>
                          Threshold Computation
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
                <Grid item xs={3}>
                  <Grid container direction='row'>
                    <Grid item>
                      <Checkbox
                        className={classes.checkbox}
                        disabled={
                          this.bulkUpdateEnabledFieldsContainFieldAndEnabled('IsPercentage') &&
                          this.state.monitor.AlertThresholds.IsPercentage === true
                        }
                        checked={this.checkIfRowIsMarked(['AlertTimeframe'])}
                        onChange={() =>
                          this.handleChangeMarked([
                            {
                              key: 'AlertTimeframe',
                              enabled: true,
                              displayTitle: 'Alert Timeframe',
                              genDisplayValue: (): string => {
                                const selectedItem = this.state.timeframeList.filter(
                                  (listItem: IListItem) => listItem.selected,
                                );
                                if (selectedItem.length) {
                                  return selectedItem[0].title;
                                }
                                return '';
                              },
                            },
                          ])
                        }
                      />
                    </Grid>
                    <Grid item>
                      <Typography className={classes.insideAccordionText}>
                        Alert Timeframe
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                {monitor.ThresholdComputation ===
                  +EMonitorThresholdComputationType.MonitorThresholdComputationType_AVG && (
                  <Grid item xs={3}>
                    <Grid container direction='row'>
                      <Grid item>
                        <Checkbox
                          className={classes.checkbox}
                          checked={this.checkIfRowIsMarked(['AveragePeriod'])}
                          onChange={() =>
                            this.handleChangeMarked([
                              {
                                key: 'AveragePeriod',
                                enabled: true,
                                displayTitle: 'Average Period',
                                genDisplayValue: (): string => {
                                  const selectedItem = this.state.averagePeriodList.filter(
                                    (listItem: IListItem) => listItem.selected,
                                  );
                                  if (selectedItem.length) {
                                    return selectedItem[0].title;
                                  }
                                  return '';
                                },
                              },
                            ])
                          }
                        />
                      </Grid>
                      <Grid item>
                        <Typography className={classes.insideAccordionText}>
                          Average Period
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
                {EnableAutoDisableObjectTypes.includes(monitor.TargetedObjectType) && (
                  <Grid item xs={3}>
                    <Grid container direction='row'>
                      <Grid item>
                        <Checkbox
                          className={classes.checkbox}
                          checked={this.checkIfRowIsMarked(['EnableAutoDisable'])}
                          onChange={() =>
                            this.handleChangeMarked([
                              {
                                key: 'EnableAutoDisable',
                                enabled: true,
                                displayTitle: 'Enable Auto Disable',
                                genDisplayValue: () =>
                                  EBool.toBoolString(this.state.monitor.EnableAutoDisable),
                              },
                            ])
                          }
                        />
                      </Grid>
                      <Grid item>
                        <Typography className={classes.insideAccordionText}>
                          Enable Auto Disable
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            )}
            {/* Monitor Type */}
            <Grid
              container
              item
              direction='row'
              justify='flex-start'
              alignItems='center'
              spacing={1}
            >
              <Grid item xs={2}>
                <Typography className={classes.insideAccordionText}>Monitor Type</Typography>
              </Grid>
              <Grid item xs={1} />
              <Grid item xs={7}>
                <Grid container direction='row'>
                  <Grid item>
                    <Select
                      value={monitor.MonitorType}
                      onChange={({ target }) => {
                        const newVal = +(target.value as any);
                        this.updateMonitorState({
                          MonitorType: newVal,
                          EnableAutoDisable:
                            newVal === EMonitorType.MonitorType_SINGLE
                              ? EBool.EBool_FALSE
                              : this.state.monitor.EnableAutoDisable, // enableAutoDisable only available for monitor type multi
                          EnableAcknowledgeAlerts:
                            newVal === EMonitorType.MonitorType_SINGLE
                              ? EBool.EBool_FALSE
                              : this.state.monitor.EnableAcknowledgeAlerts, // EnableAcknowledgeAlerts only available for monitor type multi
                        });
                      }}
                    >
                      {this.isMultiMonitorTypeAllowed(monitor.TargetedObjectType)
                        ? [
                            <MenuItem value={EMonitorType.MonitorType_SINGLE}>
                              Single Alert
                            </MenuItem>,
                            <MenuItem value={EMonitorType.MonitorType_MULTI}>Multi Alert</MenuItem>,
                          ]
                        : [
                            <MenuItem value={EMonitorType.MonitorType_SINGLE}>
                              Single Alert
                            </MenuItem>,
                          ]}
                    </Select>
                  </Grid>
                  {/*  Alert Bell Blue Box */}
                  <Grid
                    item
                    style={{
                      borderRadius: 2,
                      backgroundColor: 'rgba(213,216,249,0.28)',
                      padding: '2px 12px 2px 8px',
                      marginLeft: 10,
                    }}
                  >
                    <Grid container direction='row' alignItems='center'>
                      <Grid item>
                        <img style={{ marginTop: 4 }} src='/assets/shared/svg/Alarm.svg' />
                      </Grid>
                      <Grid item>
                        <Typography style={{ fontSize: 14 }}>
                          {isMonitorTypeSingle
                            ? '  Triggers an alert for all objects targeted above'
                            : '  Triggers separate alerts for each object targeted above'}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            {/* Condition */}
            <Grid
              container
              item
              direction='row'
              justify='flex-start'
              alignItems='center'
              spacing={1}
              style={{ marginTop: '10px', marginBottom: '1px' }}
            >
              <Grid item xs={2}>
                <Typography className={classes.insideAccordionText}>Condition</Typography>
              </Grid>
              <Grid item xs={1} />
              <Grid item xs={8}>
                <Grid
                  container
                  item
                  direction='row'
                  justify='flex-start'
                  alignItems='center'
                  spacing={3}
                >
                  {isMonitorTypeSingle ? (
                    <Grid
                      container
                      item
                      direction='row'
                      justify='flex-start'
                      alignItems='center'
                      spacing={3}
                    >
                      <Grid item>When targeted metric is</Grid>
                      <Grid item>
                        <Select
                          value={monitor.MetricDirection}
                          onChange={({ target }) => {
                            const newVal = +(target.value as any);
                            this.setState(
                              {
                                metricDirectionList: genMetricDirectionList(newVal),
                              },
                              () => {
                                this.updateMonitorState({
                                  MetricDirection: newVal,
                                });
                              },
                            );
                          }}
                        >
                          {Object.keys(metricDirectionList).map((value) => (
                            <MenuItem value={value}>{metricDirectionList[value].title}</MenuItem>
                          ))}
                        </Select>
                      </Grid>

                      {!isCustomMetric && (
                        <>
                          <Grid item>the threshold in</Grid>
                          <Grid item>
                            <Select
                              value={'' + monitor.ThresholdComputation}
                              onChange={({ target }) => {
                                const ThresholdComputation = +(target.value as any);

                                // if a Rate Metric is selected (eg. Bid Error Rate, Fill Rate) only show percentage in metric option
                                const isRateMetric =
                                  !!ELiveDataTargetedRateMetrics[monitor.TargetedMetric];
                                const isAvgMetric =
                                  !!ELiveDataTargetedAvgMetrics[monitor.TargetedMetric];
                                this.setState(
                                  {
                                    thresholdComputationTypeList: genThresholdComputationTypeList(
                                      ThresholdComputation,
                                      isRateMetric,
                                      isAvgMetric,
                                    ),
                                  },
                                  () => {
                                    this.updateMonitorState({
                                      ThresholdComputation,
                                    });
                                  },
                                );
                              }}
                            >
                              {Object.keys(thresholdComputationTypeList).map((value) => (
                                <MenuItem value={value}>
                                  {thresholdComputationTypeList[value].title}
                                </MenuItem>
                              ))}
                            </Select>
                          </Grid>
                        </>
                      )}

                      {timeframeList.length > 0 &&
                        (monitor.AlertThresholds.IsPercentage && !isCustomMetric ? (
                          <Grid item>from 48 to 24 hours ago</Grid>
                        ) : (
                          <>
                            <Grid item>
                              {isCustomMetric ? 'the threshold during last' : 'during last'}
                            </Grid>
                            <Grid item>
                              <Select
                                value={monitor.AlertTimeframe}
                                onChange={({ target }) => {
                                  const newVal = +(target.value as any);
                                  this.setState(
                                    {
                                      timeframeList: genTimeframeList(newVal),
                                    },
                                    () => {
                                      this.updateMonitorState({
                                        AlertTimeframe: newVal,
                                      });
                                    },
                                  );
                                }}
                              >
                                {timeframeList.map((value: IListItem) => (
                                  <MenuItem value={value.ID}>{value.title}</MenuItem>
                                ))}
                              </Select>
                            </Grid>
                          </>
                        ))}
                      {monitor.ThresholdComputation ===
                        +EMonitorThresholdComputationType.MonitorThresholdComputationType_AVG &&
                        !isCustomMetric && (
                          <>
                            <Grid item>average by</Grid>
                            <Grid item>
                              <Select
                                value={monitor.AveragePeriod}
                                onChange={({ target }) => {
                                  const newVal = +(target.value as any);
                                  this.setState(
                                    {
                                      averagePeriodList: genTimeframeList(newVal),
                                    },
                                    () => {
                                      this.updateMonitorState({
                                        AveragePeriod: newVal,
                                      });
                                    },
                                  );
                                }}
                              >
                                {averagePeriodList.map((value: IListItem) => (
                                  <MenuItem value={value.ID}>{value.title}</MenuItem>
                                ))}
                              </Select>
                            </Grid>
                          </>
                        )}
                    </Grid>
                  ) : (
                    <Grid
                      container
                      item
                      direction='row'
                      justify='flex-start'
                      alignItems='center'
                      spacing={3}
                    >
                      <Grid item>Alert when targeted metric is</Grid>
                      <Grid item>
                        <Select
                          value={monitor.MetricDirection}
                          onChange={({ target }) => {
                            const newVal = +(target.value as any);
                            this.setState(
                              {
                                metricDirectionList: genMetricDirectionList(newVal),
                              },
                              () => {
                                this.updateMonitorState({
                                  MetricDirection: newVal,
                                });
                              },
                            );
                          }}
                        >
                          {Object.keys(metricDirectionList).map((value) => (
                            <MenuItem value={value}>{metricDirectionList[value].title}</MenuItem>
                          ))}
                        </Select>
                      </Grid>
                      {timeframeList.length > 0 && (
                        <>
                          <Grid item>
                            {monitor.AlertThresholds.IsPercentage
                              ? 'the value from 48 to 24 hours ago'
                              : 'during last'}
                          </Grid>
                          {!monitor.AlertThresholds.IsPercentage && (
                            <Grid item>
                              <Select
                                value={monitor.AlertTimeframe}
                                onChange={({ target }) => {
                                  const newVal = +(target.value as any);
                                  this.setState(
                                    {
                                      timeframeList: genTimeframeList(newVal),
                                    },
                                    () => {
                                      this.updateMonitorState({
                                        AlertTimeframe: newVal,
                                      });
                                    },
                                  );
                                }}
                              >
                                {timeframeList.map((value: IListItem) => (
                                  <MenuItem value={value.ID}>{value.title}</MenuItem>
                                ))}
                              </Select>
                            </Grid>
                          )}
                        </>
                      )}
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>

            {/* Auto-Disable Mode */}
            {this.isEnableAutoDisableAllowed(monitor.TargetedObjectType) && (
              <Grid
                container
                item
                direction='row'
                justify='flex-start'
                alignItems='center'
                spacing={1}
                style={{ marginTop: '10px', marginBottom: '1px' }}
              >
                <Grid item xs={2}>
                  <Grid
                    container
                    direction='row'
                    justify='flex-start'
                    alignItems='center'
                    spacing={1}
                  >
                    <Grid item>
                      <Typography className={classes.insideAccordionText}>
                        Auto-Disable Mode
                      </Typography>
                    </Grid>
                    <Tooltip
                      title={`Deactivate any ${
                        targetedObjectType === 'bidder group'
                          ? 'bidder'
                          : targetedObjectType === 'channel group'
                          ? 'channel'
                          : targetedObjectType
                      } that is  ${
                        monitor.MetricDirection === 0 ? 'over' : 'under'
                      } the alert threshold condition`}
                    >
                      <Grid item>
                        <InfoIcon style={{ width: '1rem', color: '#929599' }} />
                      </Grid>
                    </Tooltip>
                  </Grid>
                </Grid>
                <Grid item xs={1} />
                <Grid item xs={8}>
                  <Grid container direction='row' alignItems='center'>
                    <Grid item>
                      <Switch
                        name='EnableAutoDisable'
                        onChange={() => {
                          const EnableAutoDisable = EBool.reverse(monitor.EnableAutoDisable);
                          this.updateMonitorState({
                            EnableAutoDisable,
                            // turn on acknowledge alerts if auto disable is on
                            EnableAcknowledgeAlerts:
                              EnableAutoDisable === EBool.EBool_TRUE
                                ? EBool.EBool_TRUE
                                : EBool.EBool_FALSE,
                          });
                        }}
                        checked={monitor.EnableAutoDisable === EBool.EBool_TRUE}
                        disabled={!this.isEnableAutoDisableAllowed(monitor.TargetedObjectType)}
                      />
                    </Grid>
                    <Grid item>
                      <span
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          width: 80,
                          fontWeight:
                            monitor.EnableAutoDisable === EBool.EBool_TRUE ? 'bold' : 'normal',
                        }}
                      >
                        {monitor.EnableAutoDisable === EBool.EBool_TRUE ? 'Active' : 'Inactive'}
                      </span>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            )}

            {/* Enable Acknowledge Alerts  */}
            {this.isEnableAutoDisableAllowed(monitor.TargetedObjectType) &&
              monitor.EnableAutoDisable === EBool.EBool_TRUE && (
                <Grid
                  container
                  item
                  direction='row'
                  justify='flex-start'
                  alignItems='center'
                  spacing={1}
                  style={{ marginTop: '10px', marginBottom: '10px' }}
                >
                  <Grid item xs={2}>
                    <Grid
                      container
                      direction='row'
                      justify='flex-start'
                      alignItems='center'
                      spacing={1}
                    >
                      <Grid item>
                        <Typography className={classes.insideAccordionText}>
                          Acknowledge Disable
                        </Typography>
                      </Grid>
                      <Tooltip title='If enabled, a shutdown will continue to notify until it is acknowledged'>
                        <Grid item>
                          <InfoIcon style={{ width: '1rem', color: '#929599' }} />
                        </Grid>
                      </Tooltip>
                    </Grid>
                  </Grid>
                  <Grid item xs={1} />
                  <Grid item xs={8}>
                    <Grid container direction='row' alignItems='center'>
                      <Grid item>
                        <Switch
                          name='EnableAcknowledgeAlerts'
                          onChange={() => {
                            const EnableAcknowledgeAlerts = EBool.reverse(
                              monitor.EnableAcknowledgeAlerts,
                            );
                            this.updateMonitorState({
                              EnableAcknowledgeAlerts,
                            });
                          }}
                          checked={monitor.EnableAcknowledgeAlerts === EBool.EBool_TRUE}
                          disabled={!this.isEnableAutoDisableAllowed(monitor.TargetedObjectType)}
                        />
                      </Grid>
                      <Grid item>
                        <span
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            width: 80,
                            fontWeight:
                              monitor.EnableAcknowledgeAlerts === EBool.EBool_TRUE
                                ? 'bold'
                                : 'normal',
                          }}
                        >
                          {monitor.EnableAcknowledgeAlerts === EBool.EBool_TRUE
                            ? 'Active'
                            : 'Inactive'}
                        </span>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              )}

            {/* Warning Threshold */}
            <Grid container direction='row' justify='flex-start' alignItems='center' spacing={1}>
              <Grid item xs={2}>
                <Grid
                  container
                  direction='row'
                  justify='flex-start'
                  alignItems='center'
                  spacing={1}
                >
                  <Grid item>
                    <Typography className={classes.insideAccordionText}>
                      Warning Threshold
                    </Typography>
                  </Grid>
                  <Tooltip title='Enables warning threshold and warning resolution threshold'>
                    <Grid item>
                      <InfoIcon style={{ width: '1rem', color: '#929599' }} />
                    </Grid>
                  </Tooltip>
                </Grid>
              </Grid>
              <Grid item xs={1} />
              <Grid item xs={8}>
                <Grid container direction='row' alignItems='center'>
                  <Grid item>
                    <Switch
                      checked={AlertThresholds.WarningThreshold !== -1}
                      onChange={() =>
                        this.updateMonitorState({
                          AlertThresholds: Object.assign(AlertThresholds, {
                            WarningThreshold: AlertThresholds.WarningThreshold === -1 ? 0 : -1,
                            WarningRecoveryThreshold:
                              AlertThresholds.WarningRecoveryThreshold === -1 ? 0 : -1,
                          }),
                        })
                      }
                    />
                  </Grid>
                  <Grid item>
                    <span
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        width: 80,
                        fontWeight: AlertThresholds.WarningThreshold !== -1 ? 'bold' : 'normal',
                      }}
                    >
                      {AlertThresholds.WarningThreshold !== -1 ? 'Active' : 'Inactive'}
                    </span>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* Alert Threshold */}
          <Grid
            container
            item
            direction='row'
            justify='flex-start'
            alignItems='center'
            style={{ marginTop: '10px', marginBottom: '1px' }}
          >
            <Grid item style={{ height: '100%' }} xs={12}>
              <Grid container direction='row'>
                <Grid item xs={2} style={{ marginTop: 10 }}>
                  <Typography className={classes.insideAccordionText}>Alert Threshold</Typography>
                </Grid>
                <Grid item xs={1} />
                <Grid item xs={8}>
                  {this.renderAlertThreshold()}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      );
    };

    mutateNotificationSettings = (mutateIDX: number, mutateObj: IMonitorNotificationSettings) => {
      const out = [] as IMonitorNotificationSettings[];
      (this.state.monitor.NotificationsSettings || []).forEach((value, index) => {
        if (index === mutateIDX) {
          out.push(mutateObj);
        } else {
          out.push(value);
        }
      });

      this.updateMonitorState({
        NotificationsSettings: out,
      });
    };

    sendTestNotificationMethod = (notification: IMonitorNotificationSettings) => {
      sendTestNotification(
        this.state.monitor.ID.toString(),
        this.props.session.publisher.ID,
        notification,
      ).then(([result, err]) => {
        if (err !== undefined) {
          console.error(err);
          this.setState({
            snackbarMessage: 'Error sending a notification: ' + err.toString(),
            snackbarError: true,
          });
        }
        if (result !== undefined) {
          this.setState({
            snackbarMessage: result.message,
            snackbarError: false,
          });
        }
      });
    };

    updateMonitorState = (override: Partial<IMonitor>, callback?: () => void) => {
      let monitor = cloneDeep(this.state.monitor); // why are we doing a clonedeep here? We reload the entire object
      monitor = Object.assign(monitor, override);

      this.setState(
        {
          monitor,
        },
        callback,
      );
    };

    addNewNotificationToList = () => {
      const newNotif: IMonitorNotificationSettings = {
        ID: 0,
        Active: EBool.EBool_TRUE,
        Provider: EMonitorNotificationProvider.MonitorNotificationProvider_EMAIL,
        MonitorID: this.state.monitor.ID,
        TriggerType: [
          EMonitorTriggerType.MonitorTriggerType_ALERT,
          EMonitorTriggerType.MonitorTriggerType_WARNING,
          EMonitorTriggerType.MonitorTriggerType_ALERT_RECOVERY,
          EMonitorTriggerType.MonitorTriggerType_WARNING_RECOVERY,
        ],
      };

      this.updateMonitorState({
        NotificationsSettings: [...(this.state.monitor.NotificationsSettings || []), newNotif],
      });
    };

    deleteFromNotificationSettings = (deletedIDX: number) => {
      const out = [] as IMonitorNotificationSettings[];
      (this.state.monitor.NotificationsSettings || []).forEach((value, index) => {
        if (index !== deletedIDX) {
          out.push(value);
        }
      });
      this.updateMonitorState({
        NotificationsSettings: out,
      });
    };

    renderNotificationSingle = (n: IMonitorNotificationSettings, idx: number) => {
      const { monitor } = this.state;
      let notifierList = GetNotifierList();
      const isSuperUser = hasRoleSuperUser(this.props.user.user);
      notifierList = notifierList.filter((e) => {
        if (e.class.IsSuperAdminOnly()) {
          return isSuperUser;
        }
        return true;
      });

      const triggerTypeList = genTriggerTypeList(monitor.AlertThresholds.WarningThreshold === -1);
      const cl = GetMonitorNotificationProviderClass(n.Provider);
      if (cl === undefined) {
        return <></>;
      }

      cl.SetReturnData((data: any) => {
        n.Data = data;
        this.mutateNotificationSettings(idx, n);
      });

      return (
        <Paper style={{ marginTop: '12px', backgroundColor: '#f9f9f9' }}>
          <Grid
            container
            direction='row'
            justify='flex-start'
            alignItems='center'
            style={{ width: '120%' }}
          >
            <Grid item xs={10} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
              <Grid container direction='column' justify='space-between' alignItems='flex-start'>
                <Grid item container direction='row' justify='space-between' alignItems='center'>
                  <Grid item xs={8} container direction='row' alignItems='center'>
                    <Grid item>
                      <p style={{ marginRight: '28px' }}>Notification type</p>
                    </Grid>
                    <Grid item>
                      <Select
                        value={n.Provider}
                        onChange={({ target }) => {
                          n.Provider = target.value as any;
                          this.mutateNotificationSettings(idx, n);
                        }}
                        renderValue={(value: any) => providerToString(value)}
                      >
                        {notifierList.map((value) => (
                          <MenuItem key={value.provider} value={value.provider}>
                            <ListItemText primary={<p>{providerToString(value.provider)}</p>} />
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>
                  </Grid>
                  <Grid item>
                    {monitor.ID > 0 && (
                      <Tooltip title='Test'>
                        <IconButton
                          aria-label='send'
                          onClick={() => {
                            this.sendTestNotificationMethod(n);
                          }}
                        >
                          <SendIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                    <Tooltip title='Delete'>
                      <IconButton
                        aria-label='delete'
                        onClick={() => {
                          this.deleteFromNotificationSettings(idx);
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                  <Grid item xs={10} container direction='row' alignItems='center'>
                    <Grid item>
                      <p style={{ marginRight: '44px' }}>Alerting Level</p>
                    </Grid>
                    <Grid item>
                      <Select
                        multiple
                        value={n.TriggerType}
                        renderValue={(targetedTypes: EMonitorTriggerType[]) => (
                          <em>
                            {(targetedTypes || [])
                              .filter((value: EMonitorTriggerType) =>
                                monitor.AlertThresholds.WarningThreshold === -1
                                  ? [
                                      EMonitorTriggerType.MonitorTriggerType_ALERT,
                                      EMonitorTriggerType.MonitorTriggerType_ALERT_RECOVERY,
                                    ].includes(value)
                                  : true,
                              )
                              .map((type) => triggerTypeToString(type))
                              .join(', ')}
                          </em>
                        )}
                        onChange={({ target }) => {
                          n.TriggerType = target.value as any;
                          this.mutateNotificationSettings(idx, n);
                        }}
                      >
                        {triggerTypeList.map((value) => (
                          <MenuItem key={value.ID} value={value.ID}>
                            <Checkbox checked={n.TriggerType.includes(value.ID)} />
                            <ListItemText primary={value.name} />
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  justify='flex-start'
                  style={{
                    paddingTop: '5px',
                    paddingBottom: '10px',
                    width: '100%',
                  }}
                >
                  {cl.Render(n)}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      );
    };

    renderNotificationsList = () => {
      const { bulkUpdateIDs, classes } = this.props;
      const bulkUpdateEnabled = !!bulkUpdateIDs && bulkUpdateIDs.length > 0;

      return (
        <div>
          {bulkUpdateEnabled && (
            <Grid item style={{ width: '100%', marginTop: '10px' }}>
              <Grid container direction='row' justify='flex-start' alignItems='center' spacing={1}>
                <Grid item xs={3}>
                  <Grid
                    container
                    direction='row'
                    justify='flex-start'
                    alignItems='center'
                    spacing={0}
                  >
                    <Grid item>
                      <Checkbox
                        className={classes.checkbox}
                        checked={this.checkIfRowIsMarked(['NotificationsSettings'])}
                        onChange={() =>
                          this.handleChangeMarked([
                            {
                              key: 'NotificationsSettings',
                              enabled: true,
                              displayTitle: 'Notifications',
                              genDisplayValue: (): string =>
                                this.state.monitor.NotificationsSettings.map(
                                  (notification: IMonitorNotificationSettings) =>
                                    getNotificationProvider(notification.Provider),
                                ).join(','),
                            },
                          ])
                        }
                      />
                    </Grid>
                    <Grid item>
                      <Typography className={classes.insideAccordionText}>Notifications</Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          )}
          {(this.state.monitor.NotificationsSettings || []).map(
            (n: IMonitorNotificationSettings, idx: number) => {
              // we don't filter before because we need the IDX to be for all notification settings
              return this.renderNotificationSingle(n, idx);
            },
          )}
          <Button
            onClick={() => {
              this.addNewNotificationToList();
            }}
            style={{
              color: getColorTheme('secondaryButtonText'),
              marginBottom: '20px',
              marginTop: '20px',
            }}
          >
            + Add a New Notification
          </Button>
        </div>
      );
    };

    // TODO add macros helper!
    renderAlertNotifications = () => {
      const { monitor } = this.state;
      const { bulkUpdateIDs, classes } = this.props;
      const { isMutedUntilTooltipOpen, updating } = this.state;
      const bulkUpdateEnabled = !!bulkUpdateIDs && bulkUpdateIDs.length > 0;

      let timeDifference = NaN;
      if (monitor.MutedUntil !== undefined && monitor.MutedUntil !== null) {
        timeDifference = Date.parse(monitor.MutedUntil.toString()) - Date.now();
      }

      let muteTxt = 'Click to Mute';
      if (!isNaN(timeDifference)) {
        muteTxt = 'Muted for ' + formatTimeDifference(timeDifference);
      }

      return (
        <div>
          {/* Mute until switch */}
          {
            // hide mute until switch for bulk update
            !bulkUpdateEnabled && (
              <Grid item>
                <ClickAwayListener
                  onClickAway={() => this.setState({ isMutedUntilTooltipOpen: false })}
                >
                  <div>
                    <Tooltip
                      classes={{
                        tooltip: classes.fullWidthTooltip,
                      }}
                      PopperProps={{
                        disablePortal: true,
                      }}
                      onClose={() => this.setState({ isMutedUntilTooltipOpen: false })}
                      open={isMutedUntilTooltipOpen}
                      disableFocusListener
                      disableHoverListener
                      disableTouchListener
                      interactive
                      title={
                        <React.Fragment>
                          <ButtonGroup
                            variant='contained'
                            aria-label='outlined primary button group'
                          >
                            {mutedUntilOptionsList.map((option: IMutedUntilOptions) => {
                              return (
                                <Button
                                  style={{
                                    backgroundColor: getColorTheme('secondaryButtonText'),
                                    color: getColorTheme('channelBidderPrimaryButtonText'),
                                  }}
                                  onClick={() => {
                                    if (option.timeOffset === null) {
                                      this.updateMonitorState({
                                        MutedUntil: undefined,
                                      });
                                      return;
                                    }
                                    const nowPlusOffset = new Date();
                                    nowPlusOffset.setHours(
                                      nowPlusOffset.getHours() + option.timeOffset,
                                    );
                                    this.updateMonitorState({
                                      MutedUntil: nowPlusOffset,
                                    });
                                  }}
                                >
                                  {option.title}
                                </Button>
                              );
                            })}
                          </ButtonGroup>
                        </React.Fragment>
                      }
                    >
                      <Button
                        onClick={() => this.setState({ isMutedUntilTooltipOpen: true })}
                        disabled={updating}
                        style={{
                          backgroundColor: getColorTheme('channelBidderPrimaryButton'),
                          color: getColorTheme('channelBidderPrimaryButtonText'),
                        }}
                      >
                        {monitor.MutedUntil ? muteTxt : 'Mute'}
                      </Button>
                    </Tooltip>
                  </div>
                </ClickAwayListener>
              </Grid>
            )
          }
          {this.renderNotificationsList()}
        </div>
      );
    };

    renderBulkUpdateSidebar = () => {
      const { bulkUpdateIDs, classes } = this.props;
      const { bulkUpdateEnabledFields } = this.state;

      const sidebarTitleMsgs = [];
      const bulkFieldsSelected =
        Object.keys(bulkUpdateEnabledFields).filter((key1) => bulkUpdateEnabledFields[key1].enabled)
          .length > 0;
      if (!bulkFieldsSelected) {
        sidebarTitleMsgs.push('Select a field to edit.');
      }
      const sidebarTitle = sidebarTitleMsgs.join(',');

      return (
        <Grid item style={{ width: '100%', paddingRight: 16 }}>
          <Paper className={classes.paper}>
            <Typography className={classes.headingCategoryTitle}>Summary</Typography>
            <Typography className={classes.insideAccordionText}>
              Current edits will impact the following:
            </Typography>
            <Typography className={classes.headingCategorySubTitle}>Monitors</Typography>
            <Typography className={classes.insideAccordionText}>
              {`${bulkUpdateIDs.length} Selected`}
            </Typography>
            <Typography className={classes.headingCategorySubTitle}>Active Fields</Typography>
            <Typography className={classes.insideAccordionText}>{sidebarTitle}</Typography>
            <Grid container direction='column' alignItems='flex-start' spacing={1}>
              {Object.keys(bulkUpdateEnabledFields)
                .filter((key1) => bulkUpdateEnabledFields[key1].enabled)
                .map((key2) => {
                  const item = bulkUpdateEnabledFields[key2];
                  return (
                    <Grid item container direction='row' alignItems='center' spacing={1}>
                      <Grid item xs={1}>
                        <Checkbox
                          className={classes.checkbox}
                          checked={true}
                          onChange={() => this.handleDisableMarkedForBulkUpdate(key2)}
                        />
                      </Grid>
                      <Grid item xs={1} />
                      <Grid item xs={6}>
                        <Typography className={classes.insideAccordionTextBold}>
                          {item.displayTitle + ':'}
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Typography className={classes.insideAccordionText}>
                          {item.genDisplayValue()}
                        </Typography>
                      </Grid>
                    </Grid>
                  );
                })}
            </Grid>
          </Paper>
        </Grid>
      );
    };

    editMonitorPanel = () => {
      const { bulkUpdateIDs, classes } = this.props;
      const bulkUpdateEnabled = !!bulkUpdateIDs && bulkUpdateIDs.length > 0;
      return (
        <Grid
          container
          direction='column'
          justify='flex-start'
          alignItems='stretch'
          style={{ width: '90%', maxWidth: 1400, marginLeft: 24 }}
          spacing={1}
        >
          <Grid item>
            <Paper classes={{ root: classes.paper }}>
              <Grid container direction='row' justify='flex-start' alignItems='stretch'>
                <Grid item xs={bulkUpdateEnabled ? 9 : 12}>
                  <Stepper orientation='vertical'>
                    <Step key={0} active={true}>
                      <StepLabel classes={{ label: classes.stepperLabel }}>
                        {'Metric Definition'}
                      </StepLabel>
                      <StepContent>{this.renderMetricDefinition()}</StepContent>
                    </Step>
                    <Step key={1} active={true}>
                      <StepLabel classes={{ label: classes.stepperLabel }}>
                        {'Alert Condition'}
                      </StepLabel>
                      <StepContent>{this.renderAlertCondition()}</StepContent>
                    </Step>
                    <Step key={2} active={true}>
                      <StepLabel classes={{ label: classes.stepperLabel }}>
                        {'Notifications'}
                      </StepLabel>
                      <StepContent>{this.renderAlertNotifications()}</StepContent>
                    </Step>
                  </Stepper>
                </Grid>
                {bulkUpdateEnabled && (
                  <Grid item xs={3}>
                    <Grid container direction='column' alignItems='flex-start'>
                      {this.renderBulkUpdateSidebar()}
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      );
    };

    renderSaveButton = () => {
      const { updating } = this.state;
      const { bulkUpdateIDs } = this.props;
      if (bulkUpdateIDs && bulkUpdateIDs.length > 0) {
        return (
          <ConfirmationDialogButton
            title='Confirm Bulk Edit Monitors'
            description={`${bulkUpdateIDs.length} selected monitors will be updated as shown in the Bulk Edit Changes section on the right side of the page.`}
            acceptButtonTitle='Update Selected Monitors'
            acceptButtonCallBack={this.updateBulkUpdateMonitors}
            refuseButtonTitle='Cancel'
            refuseButtonCallBack={noopVoid}
          >
            <Grid item>
              <Button style={getSaveButtonStyles()}>Save</Button>
            </Grid>
          </ConfirmationDialogButton>
        );
      } else {
        return (
          <Grid item>
            <Button disabled={updating} onClick={this.saveMonitor} style={getSaveButtonStyles()}>
              Save
            </Button>
          </Grid>
        );
      }
    };

    renderToolbar = () => {
      const { monitor, updating } = this.state;
      const { bulkUpdateIDs, session, user } = this.props;

      if (!bulkUpdateIDs || bulkUpdateIDs.length === 0) {
        return (
          <Toolbar style={{ color: 'black' }}>
            <Grid item style={{ maxWidth: 1100, width: '70%' }}>
              <Grid
                container
                direction='row'
                justify='space-between'
                alignItems='center'
                spacing={6}
              >
                {/* Name */}
                <Grid item>
                  <ModernTextField
                    value={monitor.Name}
                    onChange={({ target }) => {
                      this.updateMonitorState({ Name: target.value });
                    }}
                  />
                </Grid>
                {/* Active Switch */}
                <Grid item>
                  Active&nbsp;
                  <Switch
                    checked={monitor.Active === EBool.EBool_TRUE}
                    onChange={() => {
                      this.updateMonitorState({ Active: EBool.reverse(monitor.Active) });
                    }}
                  />
                </Grid>
                {/* Super User Only Switch */}
                {hasRoleSuperUser(user.user) && (
                  <Grid item>
                    Super User *&nbsp;
                    <Switch
                      checked={monitor.IsSuperAdmin === EBool.EBool_TRUE}
                      onChange={() => {
                        this.updateMonitorState({
                          IsSuperAdmin: EBool.reverse(monitor.IsSuperAdmin),
                        });
                      }}
                    />
                  </Grid>
                )}
                {/* Status */}
                <Grid>{renderMonitorStatus(getMonitorTriggerType(monitor))}</Grid>
                {/* Buttons */}
                <Grid item>
                  <Grid container justify='flex-end' spacing={2}>
                    {/* Save Button */}
                    {this.renderSaveButton()}
                    {/* Close Button */}
                    <Grid item>
                      <Button
                        onClick={() => {
                          navigate(
                            RouteMonitorList,
                            extractRouteParams({
                              session,
                              user,
                            }),
                          );
                        }}
                        style={{ color: '#545454' }}
                      >
                        Close
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Toolbar>
        );
      }

      return (
        <Toolbar style={{ color: 'black' }}>
          <Grid item style={{ width: '80%' }}>
            <Grid container direction='row' justify='space-between' alignItems='center'>
              <Grid item>
                <Typography style={{ fontSize: 14 }}>
                  Use the checkbox to the left of the field name to select a field to bulk edit and
                  input the desired value.
                </Typography>
              </Grid>
              {/* Buttons */}
              <Grid item>
                <Grid container justify='flex-end' spacing={2}>
                  {/* Save Button */}
                  <Grid item>
                    <Button
                      disabled={updating}
                      style={getSaveButtonStyles()}
                      onClick={this.updateBulkUpdateMonitors}
                    >
                      Save
                    </Button>
                  </Grid>
                  {/* Close Button */}
                  <Grid item>
                    <Button
                      onClick={() => {
                        navigate(
                          RouteMonitorList,
                          extractRouteParams({
                            session,
                            user,
                          }),
                        );
                      }}
                      style={{ color: '#545454' }}
                    >
                      Close
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Toolbar>
      );
    };

    render() {
      const { monitor, snackbarError, snackbarMessage, viewTabIndex } = this.state;
      const { classes, user, session, location } = this.props;
      const { pathname } = location;

      return (
        <Panels maxWidth vertical relative minWidthMain>
          <Panel
            largeHorizontalPadding
            verticalPadding
            style={{ borderBottom: `1px solid ${publicaColors.lightGray}` }}
          >
            <ModelTopBar
              title={routeName(pathname)}
              session={session}
              user={user}
              publisher={session.publisher}
              classes={classes}
              delegateElevate={true}
              currentPath={pathname}
              disableTitlePaddingLeft
            />
          </Panel>
          {/* Status Bar */}
          <Panel style={{ borderBottom: `1px solid ${publicaColors.lightGray}` }}>
            {this.renderToolbar()}
          </Panel>

          {/* Top Bar Margin */}
          <Panel scroll largePadding>
            {/* View Toggler */}
            <AppBar
              position='static'
              style={{ backgroundColor, boxShadow: 'none', color: 'black', marginBottom: '35px' }}
            >
              <Tabs
                value={viewTabIndex}
                onChange={(_: any, newIndex: number) => {
                  this.setState({
                    viewTabIndex: newIndex,
                  });
                }}
                aria-label='simple tabs'
                classes={{ indicator: classes.indicator }}
              >
                <Tab
                  label='Parameters'
                  {...MakeTabProps(0)}
                  style={{ color: viewTabIndex === 0 ? '#4952FF' : '#757575' }}
                />
                {monitor.ID !== 0 && (
                  <Tab
                    label='Alerts History'
                    {...MakeTabProps(1)}
                    style={{ color: viewTabIndex === 1 ? '#4952FF' : '#757575' }}
                  />
                )}
              </Tabs>
            </AppBar>

            {/* Monitor Params */}
            <TabPanel value={viewTabIndex} index={0}>
              {this.editMonitorPanel()}
            </TabPanel>

            {/* Current/ Previous Events List*/}
            <TabPanel value={viewTabIndex} index={1}>
              <MonitorHistory
                user={this.props.user}
                session={this.props.session}
                monitor={monitor}
                handleAcknowledgeMonitorAlerts={this.handleAcknowledgeMonitorAlerts}
              />
            </TabPanel>

            {/* Snackbar*/}
            <SnackbarView
              open={!!snackbarMessage}
              error={!!snackbarError}
              onClose={this.snackbarClose}
            >
              {snackbarMessage}
            </SnackbarView>
          </Panel>
        </Panels>
      );
    }
  },
);
